// ADL
import $, { data } from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from '../formAux.js';

var descriptor = [];
// var txtObj = null;
// var txtObjAdj = null;
// var gPDF = null;
// var txtTags = null;
// var tListAdj = null;
// var pageNum = null;
var mode = 'adl';
var mainLeftOffset = 70;
var reviewMode = false;
var blockEdit = false;

var gDataset = null;
var gDatasetId = null;
var gProjectId = null;
var gProject = null;

var gSelected = {};
var imgKey = null;
var modelList = null;

window.gSelected = gSelected;

// var closeIcon = '';
// var searchIcon = '';
// var mainLeftOffset = 70;

window.frm = frm;
// setTimeout( function(){window.checkInNLP()}, 1000 );

// ADLEND

// EXPORTSTART

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string' }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object && !isarray(o); }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function bool(s) {
    if (typeof (s) == 'boolean') return s;
    if (!defined(s) || s === null) return false;
    if (typeof (s) == 'number') return s > 0;
    if (s.match(/^y/i)) return true;
    return false;
}

function sbool(v) {
    return ['No', 'Yes'][v];
}

var _eventOutEvlist = [];
function eventOutside(obj, event, callback) {
    var domObj = $(obj)[0];
    function check(ev) {
        if (ev.target == domObj || $(ev.target).closest(domObj).length) return true;
        return callback(ev);
    }
    $(document.body).on(event, check);
    var e = { ev: event, cb: check };
    _eventOutEvlist.push(e);
    return e;
}

function eventOutsideEnd(e) {
    // console.log( 'eventOutsideEnd' )
    if (e) return $(document.body).off(e.ev, e.cb);
    while (_eventOutEvlist.length) {
        var e = _eventOutEvlist.pop();
        $(document.body).off(e.ev, e.cb);
    }
}

function saveClipboard(txt) {
    var input = $('<textarea>').val(txt).css({ position: 'absolute', top: px(-10000), left: px(-100000) });
    $(document.body).append(input);
    input.select();
    // input.setSelectionRange(0, 99999999);
    document.execCommand("copy");
    setTimeout(function () {
        input.remove();
    }, 100);
}

function getFilter( callback ) {
    window.post( 'get_filter', descriptor.filterMatch, res => {
        console.log( 'GET_FILTER', res.data );
        callback( res.data )
    })
}

window.getFilter = getFilter;

var imageUpdates = {};
var imageUpdateTid = null;
function setImage(img, reindex) {
    if (descriptor.blockEdit) return;
    if( !reindex ) reindex = false;
    // console.log( 'setImage', img, reindex )
    var u = {
        redOffset: defined(img.redOffset) ? img.redOffset : 1,
        greenOffset: defined(img.greenOffset) ? img.greenOffset : 1,
        brightness: defined(img.brightness) ? img.brightness : 1,
        selected: defined(img.selected) ? img.selected : false,
        classification: img.classification,
        reindex: reindex,
    }
    imageUpdates[img.fileId] = u;
    // console.log( 'setImage', JSON.stringify(imageUpdates) )

    clearTimeout(imageUpdateTid);
    imageUpdateTid = setTimeout(setImageUpdate, 200 );
}

var setImageUpdateSending = false;
function setImageUpdate(target, callback) {
    if (!descriptor.classificationMode) return;
    clearTimeout(imageUpdateTid);
    if (!target) target = 'tmp';
    if (setImageUpdateSending) return retry();
    function retry() {
        setTimeout(function () {
            console.log( 'update wait')
            setImageUpdate(target, callback)
        }, 3000);
    }

    var reindex = [];
    var sendData = clone(imageUpdates);
    for( var u in sendData ) {
        var ridx = sendData[u].reindex;
        delete sendData[u].reindex;
        if( ridx ) reindex.push(u);
    }
    imageUpdates = {};
    setImageUpdateSending = true;
    console.log( 'reindex', reindex )
    if( reindex.length ) descriptor.updating = 1;

    var tm = 0;
    function send() {
        // console.log( 'setImageUpdate', target, sendData )
        
        var payload = { bulkProject: descriptor.bulkProject, target: target, bulk: sendData, qualificationMode: descriptor.qualificationMode };
        tm = Date.now();
        console.log( 'BBULK_SAVE_START', payload.target, reindex )
        window.post('bulk_save', payload, res => {
            console.log( 'bulk_save', res );
            if (res && res.data.status) {
                descriptor.updating = 0;
                // console.log( 'saved' );
                if (res.data.trainingResult) {
                    frm.myAlert('Qualification Result', res.data.trainingResult, 'OK', end);
                } else {
                    end()
                }
            } else if( !res.data.status ) {
                console.log( 'BBULK_SAVE_error', res )
                console.error('error saving updates');
                setTimeout(send, 3000);
            } else end();
        })
    }
    
    function end() {
        setImageUpdateSending = false;
        console.log( 'BULK_SAVE_END')
        if( !callback ) callback = function(){};
        if( reindex.length ) {
            console.log( 'BBULK_SAVE_index_tasks', Date.now()-tm )
            window.post( 'index_tasks', {fileId:{$in:reindex}}, () => {
                draw();
                console.log( 'BBULK_SAVE_done', Date.now()-tm )
                callback();
            })
        } else {
            console.log( 'BBULK_SAVE_done', Date.now()-tm )
            callback();
        }
    }
    send();
}

var submitted = false;
async function submitAnnotations() {
    if (!ckAcknowledge()) return;
    if( submitted ) return;

    // var f = filters.filter( ft => ft.key != '_all' || ft.value !== '' );
    var f = filters.filter( ft => !ft.key.match(/^_all/) || ft.value !== '' );
    console.log( 'FFFFFFFFFFFFFFFFFFFFF', f )
    if( f.length ) {
        filters = [];
        drawFilter();
        var ftr = qFilter();
        console.log('QUERY FILTER', JSON.stringify(ftr))
        queryFilter = false;
        // currentPage = 0;
        descriptor.progressiveLoad( {
            start:0, 
            filter:ftr,
        }, res => {
            initImageList();
            mkAnnotationData();
            filterVisible(() => {
                actionCheck();
                draw();
                submitAnnotations()
            });
        });
        return;
    }


    // console.log( 'imageList', imageList )
    var unclassified = imageList.filter(i => !i.classification || i.classification == labelUnclassified);
    if (unclassified.length) return frm.myAlert('Unclassified Images', 'There are still <b>' + unclassified.length + '</b> unclassified images. Please classify all images before submitting', 'Ok')
    if (!ckTrain()) return
    if( !await frm.myConfirm( 'Confirm Submit', "Do you really want to submit your annotations?", null, "Yes, submit annotations", "No")) 
        return;
    frm.loading('Submiting tasks');
    if( setImageUpdateSending ) {
        setTimeout( submitAnnotations, 300 );
        return;
    }

    // var annotations = exportData();
    // if (annotations) {
    //     var d = clone(descriptor);
    //     d.dataset = annotations;
    //     saveClipboard(JSON.stringify(d, null, '\t'))
    //     console.log('\n\n\n' + JSON.stringify(annotations, null, '\t'))
    //     $('crowd-form').show();
    //     document.getElementById('annotations').value = JSON.stringify(annotations);
    // }
    // else
    //     return false;

    for (var i of imageList) setImage(i);
    var back = descriptor.userRole && descriptor.userRole.role ? 'nlpJobs' : 'nlpBrowser';
    submitted = true;
    setImageUpdate(descriptor.userRole.role, function () {
        frm.loadingOut();
        window.goPage(back);
    })
}

function resumeLater() {
    var back = descriptor.userRole && descriptor.userRole.role ? 'nlpJobs' : 'nlpBrowser';
    setImageUpdate(null, function () {
        window.goPage(back);
    })
}


function fixButtons(descriptor) {
    if (!descriptor) return;
    $('.task-button').hide();
    $('.claim-button').html('Claim Task as ' + descriptor.task_role)
    if (descriptor.blockEdit) {
        if (descriptor.task_can_claim) {
            if (descriptor.task_auto_claim) {
                setTimeout(function () {
                    $('.claim-button')[0].click();
                }, 1);
            }
            else {
                $('.claim-button').show();
            }
        }
    }
    else {
        $('.claim-button').hide();
        $('.submit-button').show();
        $('.autolabel-button').show();
        if (descriptor.task_can_decline) $('.decline-button').show();
        if (descriptor.task_can_release) {
            $('.release-button').show();
        }
    }
    reviewMode = descriptor.reviewMode
    if (reviewMode) {
        $('#reviewer-fields').show();
        $('#annotator_notes').hide();
        if (!descriptor.reviewMayRequestAdjustment) $('#optadjust').remove();
    }
    blockEdit = descriptor.blockEdit;
    $('.maincontent').find('select').attr('disabled', blockEdit)
    // $('#right').find('select').attr('disabled', blockEdit)
}

function setButtons(descriptor, form) {
    var submitButton = $('<button id="submitButton" type="submit" class="btn btn-primary btn-primary mr-2 task-button submit-button">').html('Submit Tasks');
    submitButton.on('click', submitAnnotations);
    
    var resumeLaterButton = $('<button id="resumeLaterButton" type="submit" class="btn btn-pink  mr-2 task-button submit-button">').html('Save & Exit');
    resumeLaterButton.on('click', resumeLater);

    $('.imgcls-toolbar-commands').append(submitButton);
    var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim Task');
    $('#submitButton').before(claimBtn);
    claimBtn.on('click', function () {
        claimTask(descriptor);
    });
    var declineBtn = $('<button type="submit" class="btn btn-primary btn-danger mr-2 task-button decline-button">').html('Decline');//modify Decline Task  as  Decline - mani
    $('#submitButton').after(declineBtn);
    declineBtn.on('click', function () {
        declined = claimed = released = false;
        declined = true;
        if (form) form.submit();
        else submitAnnotations();
    });
    var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('Release'); //modify Release Task  as Remove - mani
    declineBtn.after(releaseBtn);
    releaseBtn.on('click', function () {
        releaseTask(descriptor);
    });
    releaseBtn.after(resumeLaterButton)
    descriptor.fixButtons = fixButtons;

    fixButtons(descriptor);
}

window.actionCheck = actionCheck;
function actionCheck() {
    if (!descriptor.datasetMode && !descriptor.projectMode) return;
    var nselected = 0;
    for (var i of filteredImages) {
        if (i.selected) nselected++;
    }
    // console.log( 'actionCheck', descriptor.datasetMode, descriptor.projectMode, nselected )
    if (nselected) {
        var items = nselected == 1 ? ' item' : 'items'
        // $('#selectedAction').html('Actions (' + nselected + ' selected ' + items + ') <i class="fa fa-caret-down"></i>').show().prop('nselected',nselected);
        $('#selectedAction').html('Actions (' + nselected + ') <i class="fa fa-caret-down"></i>').show().prop('nselected', nselected);
    }
    else {
        // $('#selectedAction').hide();
        $('#selectedAction').html('Actions').show().prop('nselected', nselected);
        if( descriptor.datasetGlobalSearch ) $('#selectedAction').hide();
    }

    $('#exportProject').show();
    if (!filteredImages.length) $('#exportProject').hide();
    drawResize();
}

var projectList = null;

var compatibleDatasets = null;
function exportPopup(selected, mode) {
    if( !mode ) mode = 0;
    if (!mode && descriptor.projectMode) return exportTasksPopup(selected)
    if (selected) {
        selected = true;
        var itemIds = filteredImages.filter(i => i.selected).map(i => i.itemId)
    }
    else {
        selected = false;
        // var itemIds = filteredImages.map(i => i.itemId)
        var itemIds = null;
    }

    var title = selected ? 'Export selected items' : 'Export Dataset';
    var html = `<div class="force-error alert-error"></div><textarea type="text" placeholder="enter export notes"
    class="export-reason form-control mb-2"></textarea>
<div class="clonediv">
    <div id="exportProjectDiv" class="hidden">
        <label for="exportProjectList" class="form-check-label unselectable">Target Project</label>
        <select id="exportProjectList" class="mb-2 form-control">
        </select>
    </div>
    <div><select id="cloneDatasetList" class="mb-2 form-control">
    <option value="new">Clone to Dataset</option>
    </select>
<input type="text" class="form-control" id="cloneName" placeholder="Enter new Dataset name"></div>
</div>`;

    frm.myAlert(title, html, title, exportDs, 'Cancel');
    $('#clondeDataset').text('color')
    var datasetId = gDatasetId;
    var cloneMode = false;
    var bookmarkMode = false;
    var sendProjectMode = false;
    if( descriptor.datasetGlobalSearch ) {
        $('#exportItems').remove();
        $('#createBookmark').remove();
        $('#cloneOption').remove();
    }

    $('.modal-body').find('label').addClass('pointer')
    $('.modal-body').find('input:checkbox').addClass('pointer')

    $('#cloneDataset').on('change', ckClone);
    $('#exportBookmark').on('change', ckBookmark )
    $('#exportMode').on('change', () => {
        ckBookmark();
        ckClone();
        ckProject();
    })

    ckBookmark();
    ckClone();
    ckProject();

    if (!window.hasPriv('admin', 'c_admin')) $('.clonediv').hide();

    function ckBookmark() {
        // bookmarkMode = $(this).prop('checked')
        // bookmarkMode = $('#exportMode').val() == 'bookmark';
        bookmarkMode = mode == 3;
        if( !bookmarkMode ) return;
        // if (bookmarkMode && cloneMode)
        //     $('#cloneDataset')[0].click()
        if( bookmarkMode ) $('.modal-title' ).html('Create Bookmark')
        $('.modal-body').append( $('<span>Export bookmark with current view?</span>'))
        $('.export-reason')[bookmarkMode ? 'hide' : 'show']()
        btnName()
    }
    function ckClone() {
        // cloneMode = $('#cloneDataset').prop('checked');
        // cloneMode = $('#exportMode').val() == 'clone'
        cloneMode = mode == 1;
        if (cloneMode && bookmarkMode) $('#exportBookmark')[0].click()
        // console.log( 'ckClone', cloneMode )
        $('#cloneName')[cloneMode ? 'show' : 'hide']();
        // $('#modal-close').html( cloneMode? 'Clone Dataset' : 'Export Dataset')
        $('#cloneName').hide();
        if( cloneMode ) {
            $('.modal-title' ).html('Clone Items')
            $('.export-reason').hide();
            $('#cloneDatasetList').show().on('change', cloneDsSelect);
            function cloneDsSelect() {
                var cds = $('#cloneDatasetList').val();
                $('#cloneName').hide();
                if( cds == 'new' ) {
                    // $('.export-reason').show();
                    $('#cloneName').show();
                    $('#cloneName')[0].focus();
                }
                // $('.force-error').html('')
                frm.removeInlineErrors();
            }
            function setCloneDsList() {
                for( var d of compatibleDatasets ) {
                    $('#cloneDatasetList').append( $('<option value="'+d.datasetId+'">').html(d.datasetName) );
                }
            }
            if( !compatibleDatasets ) {
                compatibleDatasets = [];
                setCloneDsList();
                window.post( 'find_datasets', {sameCredentials:datasetId}, res => {
                    compatibleDatasets = res.data.records;
                    console.log( 'compatibleDatasets', compatibleDatasets )
                    setCloneDsList();
                })
            }
            cloneDsSelect();
        }
        else {
            $('#cloneDatasetList').hide();
        }
        btnName()
    }
    async function ckProject() {
        // sendProjectMode = $('#exportMode').val() == 'sendProject';
        sendProjectMode = mode == 2;
        $('#exportProjectDiv').hide();
        
        btnName();
        if (!sendProjectMode) return;
        
        $('.modal-title').html('Send to Project')
        var sp = $('#exportProjectList').html('');
        $('.export-reason').attr('placeholder', 'please enter a note')
        if (!projectList || descriptor.datasetGlobalSearch ) {
            let ptypes = {
                'Text': ['NER','TEXT_QA','Content Generation'],
                'PDF': ['NER','TEXT_QA','Content Generation'],
                'PDFOCR': ['Comprehend NER', 'OCR'],
                'PDFImage': ['Comprehend NER', 'OCR'],
                'Image': ['Bulk Image Classification', 'Classification', 'Pose Estimation','Segmentation','Key Point'],
                'Video': ['Media Transcription', 'Classification'],
                'Audio': ['Media Transcription','AmEx Audio Templete','Code Switching'],
                'Csv':["Response Generation"],
                'plain text document': ['NER'],
                'q&A': ['NER','TEXT_QA','Content Generation'],
                'pdf': ['NER'],
                'ocr processed pdf': ['Comprehend NER', 'OCR'],
                'scanned text document': ['Comprehend NER', 'OCR'],
                'image': ['Bulk Image Classification', 'Classification', 'Pose Estimation','Segmentation','Key Point'],
                'video': ['Media Transcription', 'Classification'],
                'audio': ['Media Transcription','AmEx Audio Templete','Code Switching'],
                'csv':["Response Generation"],
            }
            let dtype = gDataset.datasetType;
            if( descriptor.datasetGlobalSearch ) {
                function fix(s) { return (s).toString().toLowerCase().replace(/ +/g, ' ').trim() }
                let f = filters.find( f => f.key == 'Dataset Type');
                dtype = null;
                if( f ) {
                    for( let dt in window.DatasetTypes )
                        if( fix(window.DatasetTypes[dt]) == f.value ) dtype = dt;
                }
            }
            let allowedTypes = ptypes[dtype];
            if( descriptor.projectMode ) allowedTypes = ['Bulk Image Classification'];
            let match = { type: { $in: allowedTypes }, active: true };
            if( descriptor.projectMode ) match.id = {$ne:descriptor.projectData.id};
            
            console.log( 'FIND PROJECTS', match, 'ptypes', ptypes, 'dtype', dtype )
            let res = await window.post('find_projects', { match: match })
            projectList = {};
            var plist = res.data.records;
            plist.sort((a, b) => { return a.name < b.name ? -1 : 1 })
            for (var r of plist) {
                projectList[r.id] = { name: r.name + ' (' + window.ProjectTypes[r.type] + ')', training: r.training };
            }
        }
        console.log('projedtList', projectList)
        sp.append($('<OPTION>'));
        for (var k in projectList) {
            var o = $('<OPTION>').html(projectList[k].name).attr('value', k);
            sp.append(o);
        }
        console.log(sp.html())
        if (window.GlobalVars.PDFProjectId) sp.val(window.GlobalVars.PDFProjectId)
        if (sendProjectMode) $('#exportProjectDiv').show();
    }
    ckClone();


    function btnName() {
        var name = 'Export Dataset';
        // alert( bookmarkMode )
        if (bookmarkMode) name = 'Export Bookmark';
        else if (cloneMode) name = 'Clone Dataset';
        else if (sendProjectMode) name = 'Send to Project';
        // alert( name )
        console.log( 'btnName', name, sendProjectMode )
        $('#modal-close').html(name);
    }


    $('.export-reason').css({ height: 100 })
    // .on('keydown', function(ev) {
    //     console.log( 'keydown', ev, ev.keyCode  )
    //     if( ev.keyCode == 13 ) exportDs(ev);
    // })
    setTimeout(function () {
        $('.export-reason')[0].focus()
    }, 500)
    var exporting = false;
    function exportDs(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        frm.removeInlineErrors();
        if (exporting) return;
        var exportNote = $('.export-reason').val().trim();
        if (!exportNote && !bookmarkMode && !cloneMode ) {
            // $('.force-error').html('Please enter a note to the export');
            // $('.export-reason')[0].focus();
            frm.inlineError( $('.export-reason'), $('.export-reason').attr('placeholder'))
            return;
        }
        // console.log( 'ccc', cloneMode,  $('#cloneName').val().trim() )
        if( cloneMode ) {
            var cds = $('#cloneDatasetList').val();
            if (cds == 'new' && $('#cloneName').val().trim() == '') {
                return frm.inlineError($('#cloneName'), 'Please enter the new Dataset name' )
                // $('.force-error').html('Please enter the new Dataset name');
                // $('#cloneName')[0].focus();
                // return;
            }
        }
        if (bookmarkMode) {
            var url = document.location.origin + '/?did=' +
                descriptor.datasetData.datasetId + '&cfg=' + encodeURI(descriptor.config) + '#Dataset%20Items';
            saveClipboard(url);
            frm.myAlertClose(function () {
                frm.myAlert('Bookmark Saved', 'The <a href="' + url + '" target="_blank">bookmark URL </a> was saved in your clipboard.', 'Ok')
            })
            return;
        }
        if( sendProjectMode ) {
            let sendErr = false;
            var sproj = $('#exportProjectList').val();
            if( !sproj ) sendErr = frm.inlineError($('#exportProjectList'), 'Select a project')
            if( sendErr ) return;
            if( projectList[sproj].training && !project ) {
                frm.myAlert('Project Filter Required', "You are sending items to a Training/Qualification project.<br><br>Please select the classification project for the selected view before sending.", 'Ok')
                return;
            }
        }



        var filter = filters.filter(f => f.value).map(f => {
            if (f.key == '_all') f.key = 'All fields';
            return f.type == 1 ? { key: f.key, valueStart: f.value, valueEnd: f.value2 }
                : { key: f.key, value: f.value }
            })
        
        if( itemIds ) doExport();
        else {
            var ftr = qFilter();
            console.log( 'ftr', ftr )
            ftr._project = imgKey;
            descriptor.progressiveLoad({
                start: 0,
                end: filteredImages.length-1,
                filter: ftr,
                noLoading: true,
            }, res => {
                itemIds = res;
                doExport();
            });
        }
        function doExport() {
            var payload = { datasetId: datasetId, itemIds: itemIds, filter: filter, selection: selected, project: project || '', exportNote: exportNote, timeStamp: new Date().getTime() }
            if (cloneMode) {
                payload.cloneMode = true;
                payload.cloneDatasetId = $('#cloneDatasetList').val();
                payload.cloneName = $('#cloneName').val().trim();
            }
            if( sendProjectMode ) {
                var sproj = payload.sendProject = $('#exportProjectList').val();
                if( projectList[sproj].training ) payload.datasetProject = project;
                payload.datasetId = '';
                // if( descriptor.datasetGlobalSearch ) delete payload.datasetId;
            }

            console.log(JSON.stringify(payload))
            console.log('payloadpp', JSON.stringify(payload))
            // alert(1)
            exporting = true;
            frm.removeInlineErrors();
            // $('.force-error').html('')
            window.post('dataset_export', payload, res => {
                exporting = false;
                // console.log( 'EXPORT', res.data )
                // if (!res.data.status) return $('.force-error').html(res.data.value);
                if (!res.data.status) return frm.myAlert( 'Error', res.data.value );
                var nextPage = 'datasetExports';
                if( cloneMode ) nextPage = 'datasets';
                if( sendProjectMode ) nextPage = 'nlpProjectBrowse';
                window.goPage(nextPage);
            });
        }
    }
}


function exportTasksPopup(selected) {

    if (selected) {
        selected = true;
        var taskIds = filteredImages.filter(i => i.selected).map(i => i.fileId)
    }
    else {
        selected = false;
        // var taskIds = filteredImages.map(i => i.fileId)
        var taskIds = null;
    }

    var title = selected ? 'Export selected tasks' : 'Export Project';
    frm.myAlert(title, '<div class="force-error alert-error"></div><textarea type="text" placeholder="Enter Export Notes" class="export-reason form-control mb-2"></textarea>', title, exportProj, 'Cancel');
    $('#clondeDataset').text('color')
    var projectId = gProject.id;

    $('.modal-body').find('label').addClass('pointer')
    $('.modal-body').find('input:checkbox').addClass('pointer')

    function btnName() {
        var name = title;
        $('#modal-close').html(name);
    }


    $('.export-reason').css({ height: 100 })
    // .on('keydown', function(ev) {
    //     console.log( 'keydown', ev, ev.keyCode  )
    //     if( ev.keyCode == 13 ) exportDs(ev);
    // })
    setTimeout(function () {
        $('.export-reason')[0].focus()
    }, 500)
    var exporting = false;
    function exportProj(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        frm.removeInlineErrors();
        if (exporting) return;
        var exportNote = $('.export-reason').val().trim();
        if (!exportNote) {
            // $('.force-error').html('Please enter a note to the export');
            // $('.export-reason')[0].focus();
            frm.inlineError( $('.export-reason'), $('.export-reason').attr('placeholder'))
            return;
        }
        var filter = filters.filter(f => f.value).map(f => {
            if (f.key == '_all') f.key = 'All fields';
            return f.type == 1 ? { key: f.key, valueStart: f.value, valueEnd: f.value2 }
                : { key: f.key, value: f.value }
        })

        if( taskIds ) doExport();
        else {
            var ftr = qFilter();
            ftr._project = imgKey;
            descriptor.progressiveLoad({
                start: 0,
                end: filteredImages.length-1,
                filter: ftr,
                noLoading: true,
            }, res => {
                taskIds = res;
                doExport();
            });
        }
        function doExport(){
            var payload = { saveExport: true, filter: filter, selection: selected, match: { project: projectId, fileId: { $in: taskIds } }, exportNote: exportNote }
            // console.log( 'payload', payload )
            exporting = true;
            frm.removeInlineErrors();
            // $('.force-error').html('')
            $('.modal-title').html('Exporting tasks')
            $('.modal-body').html('')
            var exportProgress = new frm.progressBar($('.modal-body'));
            $('.modal-footer').hide();
    
    
            function check() {
                window.post('export_tasks', payload, res => {
                    var data = res.data;
                    // console.log('CHECK', data)
                    exportProgress.set(data.progress)
                    if (data.progress == 1) {
                        setTimeout(function () {
                            frm.myAlertClose(function () {
                                $('.modal-footer').show();
                                window.goPage('projectExports')
                            })
                        }, 1000)
                    }
                    else setTimeout(check, 2000)
                });
            }
            check();
        }
    }
}



// function exportProject( selected ) {

//     if (selected) {
//         selected = true;
//         var itemIds = filteredImages.filter(i => i.selected).map(i => i.itemId)
//     }
//     else {
//         selected = false;
//         var itemIds = filteredImages.map(i => i.itemId)
//     } 

//     var title = selected ? 'Export selected items' : 'Export Dataset';
//     frm.myAlert('Export Project', 'Exporting project. Please wait', 'Ok');
//     $('#modal-close').attr('disabled', true)
// }



function exportProjectPopup() {
    exportTasksPopup();
    //     var findMatch = {match:{project:gProjectId},listOnly:true}
    //     console.log( 'post', window.postParams( findMatch ))
    //     var downloadUrl = null;
    //     frm.myAlert( 'Export Project', 'Exporting, please wait.', 'Cancel')
    //     var exportProgress = new frm.progressBar( $('.modal-body') );
    //     $('.modal-footer').hide();
    //     function check() {
    //         window.post('export_tasks', findMatch, res => {
    //             var data = res.data;
    //             console.log( 'CHECK', data )
    //             exportProgress.set( data.progress )
    //             if( data.progress == 1 ) {
    //                 // alert(2)
    //                 setTimeout( function(){
    //                     frm.myAlertClose( function(){
    //                         $('.modal-footer').show();
    //                         document.location = data.url;
    //                     })
    //                 }, 1000 )
    //             }
    //             else setTimeout( check, 2000 )
    //         });
    //     }
    //     window.close = frm.myAlertClose;
    //     check();
    // 
}

function actionPopup(ev) {
    var mpos = $('.maincontent').position();
    var pos = $('#selectedAction').position();
    var nselected = $('#selectedAction').prop('nselected')

    console.log('mpos', mpos)
    if (mpos.top == 0) mpos.top = 20;
    var top = mpos.top + pos.top + $('#selectedAction').outerHeight();
    var left = mpos.left + pos.left + parseInt($('.maincontent').css('marginLeft'));
    var width = 400;
    var actionPanel = $('<DIV>').addClass('user-panel').css({ top: top, left: left, wwidth: width });
    var targetElement = descriptor.datasetMode ? 'items' : 'tasks';

    // if (window.hasPriv('admin', 'c_admin', 'c_super', 'd_super')) {
    //     actionPanel.append($('<DIV>').html('<i class="fa fa-cloud-download"></i> Export current view').on('click', function () { exportPopup(0) }));
    // }

    var embeddingModel = window.isDev && descriptor.datasetData && descriptor.datasetData.enableEmbeddingsModel && descriptor.datasetData.embeddingModelId;
    var sSelected = nselected ? ' (' + nselected + ')' : '';
    if (window.hasPriv('admin', 'c_admin', 'c_super', 'd_super') && !descriptor.datasetGlobalSearch) {
        actionPanel.append($('<DIV>').html('<i class="fa fa-cloud-download"></i> Export ' + targetElement + sSelected).on('click', function () { exportPopup(nselected) }));
    }
    if (!descriptor.blockEdit && descriptor.datasetMode) {
        if (window.hasPriv('admin', 'c_admin') && !descriptor.datasetGlobalSearch) actionPanel.append($('<DIV>').html('<i class="fa fa-cloud-download"></i> Clone to Dataset' + sSelected).on('click', function () { exportPopup(nselected, 1) }));
        if (window.hasPriv('admin', 'c_admin')) actionPanel.append($('<DIV>').html('<i class="fa fa-arrow-right"></i> Add Items to Project' + sSelected).on('click', function () { exportPopup(nselected, 2) }));
        if (window.hasPriv('admin', 'c_admin') && !descriptor.datasetGlobalSearch) actionPanel.append($('<DIV>').html('<i class="fa fa-bookmark"></i> Create Bookmark').on('click', function () { exportPopup(nselected, 3) }));
    }
    if (!descriptor.blockEdit && nselected) {
        if (embeddingModel && nselected == 1) {
            if (window.hasPriv('admin', 'c_admin', 'c_super', 'd_super') && !descriptor.datasetGlobalSearch) actionPanel.append($('<DIV>').html('<i class="fa fa-search mr-2"></i> Find similar ' + targetElement + sSelected).on('click', function () { doAction('similar') }));
        }

        if (window.hasPriv('admin', 'c_admin', 'c_super', 'd_super') && !descriptor.datasetGlobalSearch) {
            actionPanel.append($('<DIV>').html('<i class="fa fa-trash mr-2"></i> Delete ' + targetElement + sSelected).on('click', function () { doAction('delete') }));
            if (descriptor.projectMode) actionPanel.append($('<DIV>').html('<i class="fa fa-refresh"></i> Reset task' + sSelected).on('click', function () { doAction('reset') }));
        }
        actionPanel.append($('<DIV>').html('<i class="fa fa-tag"></i> Add tag' + sSelected).on('click', function () { doAction('addtag') }));
        actionPanel.append($('<DIV>').html('<i class="fa fa-close"></i> Remove tags' + sSelected).on('click', function () { doAction('deltag') }));
        if (!descriptor.datasetGlobalSearch && descriptor.datasetMode) {
            actionPanel.append($('<DIV>').html('<i class="fa fa-sitemap"></i> Run Model' + sSelected).on('click', function () { doAction('runmodel') }));
        }
    }
    if (embeddingModel) {
        if (window.hasPriv('admin', 'c_admin', 'c_super', 'd_super') && !descriptor.datasetGlobalSearch) actionPanel.append($('<DIV>').html('<i class="fa fa-refresh mr-2"></i> Regenerate embeddings'+ sSelected).on('click', function () { doAction('embeddings') }));
    }
    if (!descriptor.datasetGlobalSearch && descriptor.datasetMode && window.isDev ) {
        if (gDataset.currentRecipes) {
            let nsel = nselected ? ' ' + sSelected : ''
            for (let r in gDataset.currentRecipes) {
                if (r == 'Q&A') continue
                let rname = window.recipeActions[r];
                actionPanel.append($('<DIV>').html('<i class="fa fa-sitemap"></i>' + rname + nsel).on('click', function () { doAction('runrecipe', r) }));
            }
        }
    }
    // if( !projectData.descriptor.disableQC ) {

    //     actionPanel.append($('<DIV>').html('<i class="fa fa-check"></i> Assign tasks to Reviewing team ' + sSelected ).on('click', function () { doAction('assignReview') }));
    // }
    // if( window.GlobalVars.userRoles.length > 1 ) actionPanel.append($('<DIV>').html('<i class="fa fa-user-circle"></i> Change role').on('click', function () { window.goPage('userRole') }));
    setTimeout(function () {
        $(document.body).on('click', hideAction);
        $(document.body).append(actionPanel);
        // var left = mpos.left + $('.maincontent').width() + parseInt($('.maincontent').css('marginLeft')) - actionPanel.width();
        actionPanel.css({ left: left })
        var dleft = actionPanel.width() + left - $(window).width() + 50;
        // console.log( 'DLEFT', left, actionPanel.width(), $(window).width(), '=', dleft )
        if (dleft > 0) actionPanel.css({ left: left - dleft })


        function hideAction() {
            actionPanel.remove();
            $(document.body).off('mousedown');
        }
        // console.log('actionPopup', top, left)
    }, 100);
}

async function runPrompt() {
    var nselected = $('#selectedAction').prop('nselected');
    var dataset = gDataset;
    var project = gProject;

    var targetSel = filteredImages.filter(i => i.selected)
    var targetIds = targetSel.map(i => i.itemId)
    var targetObj = descriptor.datasetData;
    var targetLabel = nselected == 1 ? ' item' : ' items';

    let {data} = await window.post('find_recipe', {datasetId:gDataset.datasetId,recipeId:gDataset.currentRecipes['Q&A']})
    let recipe = data.records && data.records[0] || null;
    if( !recipe ) return frm.myAlert('Error', 'Invalid Q&A recipe id')
    console.log( 'RUNPROMPT', data )
    frm.myAlert( 'Query', '<textarea type="text" placeholder="Enter Tag Description" class="runPrompt mt-2 form-control"></textarea>', 'Query', async () => {
        await frm.myAlertClose();
        let exportProgress = null;
        let exportTid = null;
        let exportCancel = false;

        let promptVal = $('.runPrompt').val();

        async function recipeRun() {
            // alert( 'run')
            let param = 'Q&A';
            let {data} = await window.post('run_recipe', { itemIds: targetIds, recipeId: gDataset.currentRecipes[param], datasetId: dataset.datasetId, promptText: promptVal });
            if( !exportProgress ) {
                frm.myAlert('Prompt', 'Running prompt, please wait', 'Close', () => {
                    clearTimeout(exportTid)
                });
                exportProgress = new frm.progressBar($('.modal-body'));
                exportProgress.set(0)
            }
            console.log( 'recipeRun', data )
            exportProgress.set(data.progress)
            if( data.progress == 1 ) {
                await frm.myAlertClose();
                frm.myAlert( 'Prompt Result', data.answer, 'Ok', () => {
                    // window.goPage( 'datasetRecipes', {
                    //     datasetId: dataset.datasetId,
                    //     history: true,
                    //     recipeType: param,
                    //     view: [gDataset.currentRecipes[param]],
                    // })
                    return frm.myAlertClose();
                })
                return;
            }
            if( !exportCancel ) exportTid = setTimeout( recipeRun, 2000 );
        }
        recipeRun();

    }, 'Cancel')
    $('.runPrompt').css({height:200}).val(recipe.promptText)
    // alert( 'prompt' );
}

async function doAction(type,param) {
    var nselected = $('#selectedAction').prop('nselected');
    var dataset = gDataset;
    var project = gProject;

    if (descriptor.datasetMode) {
        var targetSel = filteredImages.filter(i => i.selected)
        var targetIds = targetSel.map(i => i.itemId)
        var targetObj = descriptor.datasetData;
        var targetLabel = nselected == 1 ? ' item' : ' items';
    }
    else {
        var targetSel = filteredImages.filter(i => i.selected)
        var targetIds = targetSel.map(i => i.fileId)
        var targetObj = descriptor.projectData;
        var targetLabel = nselected == 1 ? ' task' : ' tasks';
    }

    // console.log( 'doAction', type, targetIds )
    if (type == 'delete' ) {
        if (descriptor.datasetMode) {
            var targetDelService = 'delete_dataset_item';
            var targetDelPayload = { itemIds: targetIds }
            var txt = 'This action will remove the <b>' + nselected + ' selected ' + targetLabel + '</b> from current Dataset version. This action cannot be undone. Do you confirm?';
            if (dataset.datasetVersions[dataset.datasetVersions.length - 1].locked)
                var txt = 'This action will spawn a new Dataset version and <b>remove the ' + nselected + ' selected ' + targetLabel + '</b> from current Dataset version. This action cannot be undone. Do you confirm?';
            let confDel = await frm.myConfirm('Delete ' + targetLabel, txt, 'delete', 'Delete selected ' + targetLabel, 'Cancel')
            if( confDel ) doDel();
            // frm.myAlert('Delete ' + targetLabel, txt, 'Delete selected ' + targetLabel, doDel, 'Cancel');
        }
        else {
            var targetDelService = 'action_task';
            var targetDelPayload = { tasks: targetIds, action: 'delete' }
            var txt = 'This action will remove the <b>' + nselected + ' selected ' + targetLabel + '</b> from the project. This action cannot be undone. Do you confirm?';
            let confDel = await frm.myConfirm('Delete ' + targetLabel, txt, 'delete', 'Delete selected ' + targetLabel, 'Cancel')
            if( confDel ) doDel();
            // frm.myAlert('Delete ' + targetLabel, txt, 'Delete selected ' + targetLabel, doDel, 'Cancel');
        }


        function doDel(ev) {
            // ev.preventDefault();
            // ev.stopPropagation();
            frm.loading('Deleting ' + targetLabel);
            window.post(targetDelService, targetDelPayload, res => {
                // console.log( 'DELRES', res )
                refreshItems(function(){
                    frm.myAlertClose();
                    draw();
                });
                setTimeout( refreshItems, 500 );
                setTimeout( refreshItems, 1000 );
                setTimeout( refreshItems, 3000 );
            })
        }
    }
    else if (type == 'reset' ) {
        if (descriptor.datasetMode) {
        }
        else {
            var targetDelService = 'action_task';
            var targetDelPayload = { tasks: targetIds, action: 'reset' }
            var txt = 'This action will reset the <b>' + nselected + ' selected ' + targetLabel + '</b> from the project. This action cannot be undone. Do you confirm?';
            let conf = await frm.myConfirm('Reset ' + targetLabel, txt, 'reset', 'Reset selected ' + targetLabel, 'Cancel')
            if( conf ) doReset();
            // frm.myAlert('Delete ' + targetLabel, txt, 'Delete selected ' + targetLabel, doDel, 'Cancel');
        }


        function doReset(ev) {
            // ev.preventDefault();
            // ev.stopPropagation();
            frm.loading('Reseting ' + targetLabel);
            window.post(targetDelService, targetDelPayload, async res => {
                if( !frm.resultCheck(res)) return;
                // console.log( 'DELRES', res )
                refreshItems(function(){
                    frm.myAlertClose();
                    draw();
                });
                // setTimeout( refreshItems, 500 );
                // setTimeout( refreshItems, 1000 );
                // setTimeout( refreshItems, 3000 );
            })
        }
    }
    else if (type == 'similar') {
        let maxItems = window.GlobalVars.findSimilarMaxItems || 50;
        frm.myAlert('Search similar items', '<label for="maxresult">Max number of items</label><input placeholder="Max number" type="text" id="maxresult" class="mb-4 form-control" value="'+maxItems+'">', 'Find Similar', doFindSimilar, 'Cancel');
        async function doFindSimilar() {
            maxItems = window.GlobalVars.findSimilarMaxItems = $('#maxresult').val()*1;
            frm.loading('Finding similar items')
            await window.saveSession();
            let data = (await window.post('search_text_embeddings',{itemId:targetIds[0], num: maxItems})).data;
            // console.log( 'targetIds', targetIds )
            window.GlobalVars.currentDataset.similarSearch = {itemId:targetIds[0],result:data.records.map( v => v.item_id )};
            await window.saveSession();

            console.log( 'SIMILARSEACHRESULT', JSON.stringify(data.records, null, '\t') )
            refreshItems(function(){
                frm.loadingOut();
                draw();
            });
        }
    }
    else if (type == 'embeddings' ) {
        let payload = { itemIds: targetIds, datasetId: dataset.datasetId, filter: descriptor.loadFilter };
        let nelements = 'ALL items';
        let confirm = 'regenerate all';
        if( targetIds.length ) {
            nelements = targetIds.length + ' item';
            if( targetIds.length != 1 ) nelements += 's';
            confirm = 'regenerate'
        }
        let confEmb = await frm.myConfirm('Confirm Embeddings Regeneration', "Do you really want regenerate embedings for <b>"+nelements+"</b>?", confirm, 'Regenerate Embeddings', 'Cancel')
        if( !confEmb ) return;
        let {data} = await window.post('regenerate_embeddings', payload );
        let tid = setTimeout( function() { document.location.reload() }, 3000 )
        frm.myAlert('Embeddings', 'Items are being reprocessed. Please wait.', 'Ok', () => {
            clearTimeout( tid );
            document.location.reload();
        });
        // new frm.progressBar($('.modal-body')).set(87);
        return;
        /// AQUI
    }
    else if (type == 'addtag') {
        frm.myAlert('Add tags', '<div class="tag-wrap"><div class="dataset-tags"></div><input type="text" placeholder="Enter Tag Name" class="add-tags form-control"><textarea type="text" placeholder="Enter Tag Description" class="mt-2 add-tags-description form-control"></textarea><div class="project-panel add-tags-project"><input type="checkbox" id="addtagproj" class="fform-control"> Also add tag to growndtruth project</div></div>', 'Add Tag', doAddTag, 'Cancel');

        var tag = null;
        var description = null;
        var inp = null;

        if (!targetObj.tags) targetObj.tags = {};
        // var ctags = Object.keys(targetObj.tags).map( k => {
        //     return {
        //         value: k,
        //         label: k + (targetObj.tags[k].description ? ' - '+targetObj.tags[k].description : ''),
        //     }
        // });

        var ctags = Object.keys(targetObj.tags);

        function fixTag(t) { return t.toString().replace(/\./g,'_').replace(/^\$/,'_').split(' ').map(t => t.replace(/[ \n\t]+/g, '').trim()).filter(t => t.length > 0).join(' ') }

        function addTag() {
            $('.dataset-tags').hide();
            $('.add-tags').show().off('change').on('change', function () {
                let tag = selTag($(this).val())
                $(this).val(tag)
            });
            $('.add-tags-description').val('').show();
            setTimeout(function () {
                $('.add-tags')[0].focus()
            }, 500)
        }

        let lastTag = null;
        function selTag(t) {
            tag = fixTag(t);
            if( tag == lastTag ) return;
            lastTag = tag;

            if (targetObj.tags[tag]) $('.add-tags-description').val(targetObj.tags[tag].description || '')
            $('.add-tags-description').show()
            if( groundtruthProject ) $('.add-tags-project').show()
            setTimeout(function () {
                if (!targetObj.tags[tag] || !targetObj.tags[tag].description) return $('.add-tags-description')[0].focus()
                $('#modal-close')[0].focus()
            }, 100)
            console.log( 'tag', tag )
            if( ctags.indexOf('tag') == -1 ) {
                ctags.push(tag);
                if( inp ) inp.setOptions(ctags, tag);
            }
            return tag;
        }
        $('.add-tags').hide();
        $('.add-tags-description').hide().css({ height: 200 }).on('keydown', function (ev) {
            // console.log( 'keydown', ev, ev.keyCode  )
            if (ev.keyCode == 13) doAddTag(ev);
        })
        $('.add-tags-project').hide();


        if (!ctags.length) return addTag();
        ctags.sort();
        // ctags.unshift({value:-1,label:'(Add new tag)'});
        ctags.unshift({ value: '', label: '' });

        var inp = frm.dropDown($('.dataset-tags'), ctags, '', { allowNew: true, placeholder: 'Select Tag', width: '100%' }, function (v) {
            if (v === '') return;
            v = fixTag(v);
            // if( ctags.indexOf(v) == -1 )
            // if (v == -1) addTag();
            // selTag(v);
            setTimeout(function () {
                selTag(v)
            }, 1)
        });
        window.dropdown = inp;
        $('.tag-wrap').css({ height: 300 })
        window.inp = inp;
        // setTimeout(function () {
        //     inp.find('button')[0].click();
        //     $('.add-tags-description').hide();
        //     setTimeout(function () {
        //         inp.find('input')[0].focus();
        //     }, 100)
        // }, 100);
        function doAddTag(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if (!tag) return;
            var description = $('.add-tags-description').val().toString().trim();
            if (!targetObj.tags[tag]) targetObj.tags[tag] = { count: targetIds.length }
            targetObj.tags[tag].description = description;
            if (descriptor.datasetMode) {
                var targetAddTagService = 'add_tag_dataset_item';
                var targetAddTagPayload = { itemIds: targetIds, tag: tag, description: description, datasetId: dataset.datasetId }
                if( descriptor.datasetGlobalSearch ) targetAddTagPayload.datasetId = '';
                var targetId = 'itemId';
                if( $('#addtagproj').prop('checked') == true) {
                    targetAddTagPayload.project = groundtruthProject;
                }
            }
            else {
                var targetAddTagService = 'add_tag_task';
                var targetAddTagPayload = { taskIds: targetIds, tag: tag, description: description, project: project.id }
                var targetId = 'fileId';
            }
            // console.log( tag );
            frm.myAlertClose(() => {
                frm.loading('Updating ' + targetLabel);
                console.log('UPDATING',targetAddTagPayload)
                window.post(targetAddTagService, targetAddTagPayload, async res => {
                    console.log('UPDATED')
                    if( !frm.resultCheck(res)) return;

                    frm.loading('Refreshing ' + targetLabel);
                    targetSel.forEach(d => {
                        delete d.selected;
                        delete gSelected[d[imgKey]]
                        if (!d.tags) d.tags = {};
                        d.tags[tag] = 1
                    });
                    // init(descriptor, true)
                    frm.loadingOut();
                    console.log('mkAnnotationData')
                    mkAnnotationData();
                    console.log('mkFilterData')
                    mkFilterData();
                    console.log('setFilters')
                    setFilters();
                    draw();
                    console.log('DONE')
                    setTimeout( refreshItems, 2000 );
                    setTimeout( refreshItems, 5000 );
    

                    // refreshItems( frm.myAlertClose );
                });
            });
        }
    }
    else if (type == 'deltag') {
        var allTags = {};
        var tlist = targetSel.map(i => Object.keys(i.tags||{}));
        for (var tl of tlist)
            for (var t of tl)
                allTags[t] = 1;
        allTags = Object.keys(allTags);
        allTags.sort();
        // console.log( 'allTags', allTags )  
        if (allTags.length == 0) return frm.myAlert('Remove Tags', 'There are no tags to be removed from the selected ' + targetLabel, 'Ok');
        frm.myAlert('Remove tags', '<div class="del-tags"><div>Select the tags to be removed from the selected ' + targetLabel + ':</div></div>', 'Del Tags', doDelTag, 'Cancel');
        $('#modal-close').attr('disabled',true);
        var tagsToDel = {};
        function drawTag(t) {
            var but = $('<button class="mr-1 mt-1 btn btn-primary">' + t + '</button>').prop('sel', 0).prop('tag', t).on('click', function (ev) {
                var sel = $(this).prop('sel');
                // console.log( 'click', $(this).prop('tag'), sel )
                if (sel) {
                    $(this).removeClass('btn-danger').addClass('btn-primary').prop('sel', 0);
                    delete tagsToDel[$(this).prop('tag')]
                } else {
                    $(this).removeClass('btn-primary').addClass('btn-danger').prop('sel', 1);
                    tagsToDel[$(this).prop('tag')] = 1;
                }
                $('#modal-close').attr('disabled', Object.keys(tagsToDel).length == 0 )
            })
            $('.del-tags').append(but);
        }
        for (var t of allTags) drawTag(t);
        function doDelTag(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var tags = Object.keys(tagsToDel);
            if (descriptor.datasetMode) {
                var targetDelTagService = 'del_tag_dataset_item';
                var targetDelTagPayload = { itemIds: targetIds, tags: tags, datasetId: dataset.datasetId }
                var targetId = 'itemId';
            }
            else {
                var targetDelTagService = 'del_tag_task';
                var targetDelTagPayload = { taskIds: targetIds, tags: tags, project: project.id }
                var targetId = 'fileId';
            }
            // console.log( 'delTags', tags );
            frm.myAlertClose(() => {
                frm.loading('Updating ' + targetLabel);
                window.post(targetDelTagService, targetDelTagPayload, async res => {
                    if( !frm.resultCheck(res)) return;
                  
                    frm.loading('Refreshing ' + targetLabel);
                    targetSel.forEach(d => {
                        delete d.selected;
                        delete gSelected[d[imgKey]];
                        if (d.tags) for (var tag of tags) delete d.tags[tag]
                    });
                    // init(descriptor, true)
                    refreshItems(function(){
                        frm.loadingOut();
                        mkAnnotationData();
                        mkFilterData();
                        setFilters();
                        // queryFilter = true;
                        draw();
                        setTimeout( refreshItems, 500 );
                        setTimeout( refreshItems, 1000 );
                        setTimeout( refreshItems, 3000 );
                        setTimeout( refreshItems, 5000 );
                    });
                });
            })
        }
    }
    else if (type == 'runmodel') {
        frm.myAlert('Run Model', '<div class="force-error alert-error"></div><div class="tag-wrap"><div class="run-model-choose"></div><textarea type="text" placeholder="Enter Run Model Note" class="mt-2 run-model-description form-control"></textarea></div>', 'Run Model', doRunModel, 'Cancel');
    
        var model = null;
        var description = null;
    
    
        function fixTag(t) { return t.toString().replace(/\./g,'_').replace(/^\$/,'_').split(' ').map(t => t.replace(/[ \n\t]+/g, '').trim()).filter(t => t.length > 0).join(' ') }
    
        $('.run-model-description').hide().css({ height: 200 }).on('keydown', function (ev) {
            if (ev.keyCode == 13) doRunModel(ev);
        })
    
    
    
        // window.dropdown = inp;
        // window.inp = inp;
        let runModelId = null;

        let mtypes = {
            'Text': ['custom_ner'],
            'PDF': ['custom_ner'],
            'PDFOCR': ['custom_ocr'],
            'PDFImage': ['custom_ocr'],
            'Image': ['custom_bulkimageclassification'],
        }
        let allowedTypes = mtypes[gDataset.datasetType];
    
        function initRun() {
            if( modelList == null ) {
                $('.run-model-choose').html('Loading modules...')
                window.post('find_models',{match:{type:{$in:allowedTypes}}}, res => {
                    modelList = res.data.records.map( m => {return {
                        value: m.id,
                        label: m.name,
                    }})
                    console.log( 'modelList', modelList )
                    modelList.unshift({label:'&nbsp;',value:''})
                    initRun();
                } )
                return;
            }
            else {
                $('.run-model-choose').html('')
                $('.tag-wrap').css({ height: 280 })
                let last = null;
                var inp = frm.dropDown($('.run-model-choose'), modelList, '', { allowNew: false, placeholder: 'Select Model', width: '100%' }, function (v) {
                    frm.removeInlineErrors();
                    runModelId = v;
                    if( runModelId ) {
                        $('.run-model-description').show();
                        setTimeout( function(){ $('.run-model-description')[0].focus() }, 500 )
                    }
                    else {
                        $('.run-model-description').hide();
                    }
                });
                // setTimeout(function () {
                //     inp.find('button')[0].click();
                //     $('.run-model-description').hide();
                //     setTimeout(function () {
                //         inp.find('input')[0].focus();
                //     }, 100)
                // }, 100);
            }
            return;
        }
        initRun();
        function doRunModel(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            frm.removeInlineErrors();
            var runNote = $('.run-model-description').val().trim();
            // if( !runModelId ) return $('.force-error').html('Select a model');
            if( !runModelId ) return frm.inlineError( $('.run-model-choose'), 'Select a model');
            
            if( !runNote ) {
                return frm.inlineError( $('.run-model-description'), 'Please add a note about this model run');
                // setTimeout( function(){
                //     $('.run-model-description')[0].focus()
                // }, 500 )
                // return $('.force-error').html('Please add a note about this model run');
            }
            // $('.force-error').html('')
            window.post('model_run', {itemIds:targetIds,modelId:runModelId,datasetId:dataset.datasetId,note:runNote}, res => {
                frm.myAlertClose( () => {
                    if( !res.data.status ) return frm.myAlert('Run Model', res.data.value );
                    window.goPage('datasetModelRuns')
                })
            })
        }
    }
    else if (type == 'runrecipe') {
        // frm.myAlert('Run Recipe', param + '<br>' + targetIds.join(', '), 'Run Model');

        // frm.loading('Running recipe');
        let exportProgress = null;
        let exportTid = null;
        let exportCancel = false;

        async function recipeRun() {
            let {data} = await window.post('run_recipe', { itemIds: targetIds, recipeId: gDataset.currentRecipes[param], datasetId: dataset.datasetId });
            if( !exportProgress ) {
                frm.myAlert(data.recipeName, 'Dataset items are being processed, please wait.', 'Close', () => {
                    clearTimeout(exportTid)
                });
                exportProgress = new frm.progressBar($('.modal-body'));
                exportProgress.set(0)
            }
            console.log( 'recipeRun', data )
            exportProgress.set(data.progress)
            if( data.progress == 1 ) {
                window.goPage( 'datasetRecipes', {
                    datasetId: dataset.datasetId,
                    history: true,
                    recipeType: param,
                    view: [gDataset.currentRecipes[param]],
                })
                return frm.myAlertClose();
            }
            if( !exportCancel ) exportTid = setTimeout( recipeRun, 2000 );
        }
        recipeRun();
        // console.log( 'run', data )

		// 				exportProgress = new frm.progressBar($('.modal-body'));
		// 				// $('.modal-footer').hide();
		// 			}
		// 			exportProgress.set(progress)


        // frm.myAlert('Run response', '<pre>'+ JSON.stringify(data, null, '   ') +'</pre>')
        // $('.modal-dialog').css({maxWidth: 1024})
        // frm.loadingOut();
    }    
    else if (type == 'export') {
        frm.myAlert('Export Selected ' + targetLabel, 'Under construction', 'Ok')
    }
}

function setFilters() {
    mkAnnotationData();
    mkFilterData();
    drawFilter();
}

window.setFilters = setFilters;

function refreshItems(callback) {
    var page = currentPage;
    var ftr = qFilter();
    var prevf = JSON.stringify(filterConfig);
    var prevc = filteredImages.length;
    descriptor.progressiveLoad( {
        start:0, 
        filter:ftr,
    }, res => {
        console.log( 'REFRESHITEMS', res )
        currentPage = page;
        if( callback ) initImageList();
        mkAnnotationData();
        mkFilterData();
        if( JSON.stringify(filterConfig) != prevf ) drawFilter();
        filterVisible( () => {
            if( filteredImages.length != prevc ) draw();
            actionCheck();
            if( callback ) callback();
        });
    });
    // if (descriptor.datasetMode) {
    //     var datasetId = gDatasetId;
    //     window.post('find_datasets', { match: { datasetId: datasetId } }, res => {
    //         var data = res.data;
    //         if (!data || !data.records.length) return window.goPage('datasets');
    //         var nd = data.records[0];
    //         for (var k in nd) gDataset[k] = nd[k];
    //         window.saveSession(() => {
    //             window.post('dataset_items', { datasetId: datasetId }, res => {
    //                 descriptor.dataset = res.data.records;
    //                 init(descriptor, true)
    //                 frm.loadingOut();
    //                 setFilters();
    //                 if (callback) callback();
    //             })
    //         });
    //     })
    // }
    // else {
    //     var projectId = descriptor.projectData.id;
    //     window.post('find_projects', { match: { id: projectId } }, res => {
    //         var data = res.data;
    //         if (!data || !data.records.length) return window.goPage('nlpBrowse');
    //         var nd = data.records[0];
    //         for (var k in nd) gProject[k] = nd[k];
    //         window.saveSession(() => {
    //             window.post('bulk_tasks', { bulkProject: projectId, match: { project: projectId } }, res => {
    //                 descriptor.dataset = res.data.tasks;
    //                 init(descriptor, true)
    //                 frm.loadingOut();
    //                 setFilters();
    //                 if (callback) callback();
    //             })
    //         });
    //     })
    // }
}

window.refreshItems = refreshItems;

var claimTask = function () {
    descriptor.blockEdit = blockEdit = false;
    fixButtons(descriptor);
    // alert( 'claim')
}

var releaseTask = function () {
    descriptor.blockEdit = blockEdit = true;
    fixButtons(descriptor);
}




var changeList = [];
var changed = function (o) {
    // console.log( 'changed', o )
}

function exportData(nocheck) {
    var out = clone(imageList);
    for (var o of out) {
        if (o.classification == labelUnclassified) delete o.classification;
        delete o.id;
    }
    return out;
}


$('crowd-form').hide();

var imagesPage = 500;
var imageZoom = 5;
var labelUnclassified = 'Unclassified'
var selectedTab = labelUnclassified;
var currentPage = 0;
var itemsPerPage = 20;
var imageLastTouched = null;
var imageClicked = null;
var showLabels = false;
var showDetails = false;
var showControls = false;
var declined = false;
var claimed = false;
var released = false;


function addSlider(hook, conf, callback) {

    var label = conf.label || '';
    var min = conf.min || 0;
    var max = conf.max || 100;
    var reset = ('reset' in conf) ? conf.reset : max / 2;
    var ini = ('ini' in conf) ? conf.ini : conf.reset;
    if (conf.switch) {
        min = 0;
        max = 1;
        reset = ini;
    }

    var id = 'tmp' + getsec();
    var cont = $('<div>').addClass('imgcls-range-cont')
    if (conf.addClass) cont.addClass(conf.addClass);
    var label = $('<label for="' + id + '">' + label + '</label>')
    var slider = $('<input type="range" id="' + id + '" min="' + 0 + '" max="' + 100 + '">').addClass('imgcls-range').on('input', slide).on('change', slide).on('click', click);
    var value = $('<span>').addClass('imgcls-range-val').html('');

    cont.css({ width: conf.width || 300 })
    if (conf.labelWidth) label.css({ width: conf.labelWidth })
    if (conf.switch) slider.addClass('imgcls-switch')

    // if( conf.sliderWidth ) slider.css({width:conf.sliderWidth})
    var delta = max - min;
    function slide(ev) {

        var v = ($(this).val() / 100) * delta + min;
        // console.log( 'xxx', min, max, delta, $(this).val()/100)
        callback(v)
    }

    function switchChange(ev) {
        var v = slider.val() > 0 ? 0 : 1;
        set(v);
        // console.log( 'switch', v, conf.showValue )
        callback(v);
    }

    if (conf.switch) {
        slider.off('input').off('click').on('mousedown', function (ev) { ev.preventDefault() })
        cont.on('click', switchChange).addClass('imgcls-slider-switch')
    }
    var clicked = false;
    var clickedTid = null;
    function click(ev) {
        if (clicked) callback(set(reset));
        clicked = true;
        clearTimeout(clickedTid);
        clickedTid = setTimeout(function () { clicked = false }, 500);
        ev.stopPropagation();
    }
    cont.append(label, slider, value);
    hook.append(cont);
    slider.css({ position: 'relative', left: -1000 })
    function sliderWidth() {
        if (conf.switch) return slider.css({ position: '', left: 'auto', width: 30 })
        var less = label.outerWidth() + value.outerWidth() + 10;
        if (less >= cont.width()) return;
        // console.log( 'less', less, label.outerWidth(), value.outerWidth(), cont.width())
        // console.log( 'slider', slider.width())
        slider.css({ position: '', left: 'auto', width: 'calc(100% - ' + less + 'px)' })
    }
    setTimeout(sliderWidth, 1)
    function set(v) {
        if (defined(v)) {
            slider.val(100 * (v - min) / delta);
            if (conf.showValue) {
                value.html(conf.showValue(v));
                // console.log( 'showValue', v, conf.showValue(v))
                sliderWidth();
            }
        }
        return (slider.val() / 100) * delta + min;
    }
    set(ini);
    return { input: slider, val: set, s: sliderWidth };
}

function cleanImages() {
    // imageList = [];
    $('.imgcls-image-container').remove();
}

function clearSelected() {
    for (var i of imageList) if (i.classification == selectedTab && i.selected) {
        i.selected = false;
        delete gSelected[i[imgKey]]
        setImage(i)
    }
    countSelected();
}

function countSelected() {
    var scount = 0;
    for (var i of imageList) if (i.classification == selectedTab && i.selected) scount++;
    // $('.selected-images').html('Classify Selected (' + scount + '): ')   Remove Semi-colan Mani
    $('.selected-images').html('Classify Selected (' + scount + ') ')
}

function adjustImages() {
    for (var img of imageList) {
        img.adjust();
    }
}

var rolloverCurrent = null;
function rolloverDetail( obj, data ) {
    rolloverDetailOut()
    let browser = $('.imgcls-browse');
    let bpos = browser.offset();
    let margin = 10;
    bpos.top -= browser.scrollTop();
    let pos = obj.offset();
    pos.top -= bpos.top;
    pos.left -= bpos.left;
    let owid = obj.width();
    let bwid = browser.width();
    let bheight = $('.imgcls-browse').outerHeight();
    let pwid = bwid*.4;
    let roll = $('<DIV>').addClass('imgcls-rollover-detail').html('<div class="imgcls-rollover-wrapper"></div>');
    let css = {top:pos.top, height: bheight*.8};
    let bvh = bheight + browser.scrollTop();
    if( css.top + css.height > bvh ) css.top = bvh - margin - css.height;
    css.left = pos.left + owid + margin;
    roll.css( css )
    rolloverCurrent = data.id;
    roll.on('mouseover', function(){
        clearTimeout( iOutTid );
    });
    roll.on( 'mouseout', function(){ 
        imageOut( obj, data )
        zoomOut();
    });
    let src = obj.find('img').attr('src');
    if( src.match(/presigned/)) src += '&adl=1'
    let imgWid = 0;
    let imgHeight = 0;
    let img = $('<IMG>').attr('src', src).css({height: css.height-2}).on('load', function(){
        imgWid = $(this).width();
        imgHeight = $(this).height();
        wrapper.css({width:imgWid})
        roll.css({width:imgWid})
        if( pos.left > bwid/2 ) {
            roll.css({left: (pos.left-margin-roll.width())});
        }
    })
    let zoomFactor = 3;
    function zoom(ev) {
        let wpos = roll.offset();
        let rx = (ev.pageX-wpos.left)/roll.width();
        let ry = (ev.pageY-wpos.top)/roll.height();
        let a = zoomFactor*(1-(1/zoomFactor));
        // console.log( ev.clientX, ev.clientY, 'wpos', wpos, a, rx, ry, ev )
        let left = -imgWid*a*rx;
        let top = -imgHeight*a*ry;
        wrapper.css( {transform: 'scale('+zoomFactor+')', top: top, left: left} )
    }
    function zoomOut() {
        wrapper.css( {transform: 'scale(1)', top: 0, left: 0} )
    }
    let wrapper = roll.find('.imgcls-rollover-wrapper')
    roll.on('mousemove', zoom )
    wrapper.append(img)
    browser.append( roll );
    if( pos.left > bwid/2 ) {
        roll.css({left: (pos.left-margin-roll.width())});
    }
    // console.log( 'rolloverDetail', src, pos, browser.height(), css )
}

function rolloverDetailOut( cTimeout ) {
    // console.log( 'rolloverDetailOut')
    if( cTimeout ) clearTimeout( iOverTid );
    $('.imgcls-rollover-detail').remove();
    rolloverCurrent = null;
}

var iOverTid = null;
var iOutTid = null;
function imageOver( obj, data ) {
    clearTimeout( iOverTid );
    if( data.id === rolloverCurrent ) return clearTimeout( iOutTid );
    if( data.state == 15 ) return;
    iOverTid = setTimeout( function(){ rolloverDetail( obj, data)}, 1000 );
    // console.log( 'imageOver', obj[0], data )
}

function imageOut( obj, data ) {
    // console.log( 'imageOut', obj[0], data )
    clearTimeout( iOutTid );
    clearTimeout( iOverTid );
    iOutTid = setTimeout( function(){ rolloverDetailOut()}, 100 );
}

var imageList = [];
var imgClick = false;
var imgClickTid = false;
var detailSelected = null;
function addImage(hook, conf, isDetail) {
    var before = null;
    if (isDetail && isDetail !== 1) before = isDetail;
    if( isDetail ) rolloverDetailOut(true)
    var fid = 'filter' + getsec() + imageList.length;
    var fid = 'filter' + conf.id;
    var iid = 'image_' + conf.id;
    var url = conf.imageUrl || '';
    if( conf.type == 'image/tiff' && !url.match(/\.png$/)) url += '.png';
    var label = conf.label || '';
    var roff = 'redOffset' in conf ? conf.redOffset : 1;
    var goff = 'greenOffset' in conf ? conf.greenOffset : 1;
    var boff = 'blueOffset' in conf ? conf.blueOffset : 1;
    var brightness = 'brightness' in conf ? conf.brightness : 1;

    var slabel = showLabels || (isDetail && descriptor.detailLayout.showLabels);
    var sdetail = showDetails || (isDetail && descriptor.detailLayout.showDetails);
    var scontrol = showControls || (isDetail && descriptor.detailLayout.showControls);
    var rolloverPreview = descriptor.gridLayout.rolloverPreview;

    var cell = $('<div>').addClass('imgcls-image-container').prop('imageid', conf.id).prop('id', iid);
    if (isDetail) {
        var close = $('<div>').addClass('imgcls-image-container-detail-close').html('<i class="fa fa-close"></i>').on('click', function () {
            hideDetail();
        });
        cell.append(close);
    }
    if (isDetail) cell.addClass('imgcls-image-container-detail')
    var cont = $('<div>').addClass('imgcls-image-wrapper').css({ display: 'block', width: 'calc(100%)' })
    cont.prop( 'imgData', conf )
    if( rolloverPreview ) {
        cont.on('mouseover', function(){
            imageOver( cont, conf );
        } );
        cont.on('mouseout', function(){
            imageOut( cont, conf )
        } )
    }
    cell.append(cont)
    if(!isDetail) {
        var arrow = $('<div>').addClass('img-arrow').html('')
        cell.append(arrow);
    }
    var imgBox = $('<div>').addClass('imgcls-image-box')
    if (isDetail) imgBox.addClass('imgcls-image-box-detail')
    var tooltip = '';
    if (descriptor.imageLayout.toolTip) tooltip = descriptor.imageLayout.toolTip(conf);
    imgBox.prop('title', tooltip)
    if (conf.selected) cell.addClass('imgcls-image-selected')
    var img = $('<img>').addClass('imgcls-image').prop('src', '');
    // console.log( 'getPresignedImage', img[0] )
    frm.getPresignedImage(img, conf.datasetId ? { dataset: conf.datasetId } : descriptor.presignedConfig, url);
    imgBox.append(img);
    cont.append(imgBox);
    if( conf.processingError ) img.attr('title', conf.processingError )

    var detWrapper = $('<div>').addClass('imgcls-image-detail-wrapper');
    cont.append(detWrapper)
    var dlabel = $('<div>').addClass('imgcls-image-label')
    if (slabel) dlabel.html(label)
    detWrapper.append(dlabel);
    var labelWidth = '2em';

    // var size = zoomSize();
    // if( conf.isDetail ) size *= 2;
    // cell.css({ width: size })
    // imgBox.css({ width: size - 10, height: size - 10 })

    // if (sdetail && (conf.annotationData || conf.metadata)) {
    if (sdetail) {
        var details = $('<div>').addClass('imgcls-image-details').addClass('scroll-blue') //modify scroll-thin as scroll-blue mani
        var dcontent = details;
        var ncard = 0;
        var cid = '';
        function dcard() {
            cid = 'img_card_'+ncard;
            dcontent = $('<div id="'+cid+' "class="collapse show" aria-labelledby="headingThirty-Two" id="#accordion"></div>').addClass('imgcls-detail-card');
            details.append(dcontent);
            ncard++;
        }
        function dtit(s) {
            dcard();
            // var b = $('<button class="btn-link bg-transparent btn-block text-left collapsed acc border-0" type="button" data-toggle="collapse" data-target="#'+cid+'" aria-expanded="true" aria-controls="'+cid+'"></button>');
            // var i = $('<i class="fa fa-chevron-down acc "></i>')
            // var d = $('<span>').addClass('iimgcls-image-detail-line-title').html(s);
            // b.append(d,i)
            // dcontent.append(b)

            var d = $('<div>').addClass('imgcls-image-detail-line-title').html(s);
            dcontent.append(d)

            return d;
        }
        function dval(k, v) {
            var d = $('<div>').addClass('imgcls-image-detail-line').html('<b>' + k + ':</b> ' + v)
            d.prop('title', d.text())
            dcontent.append(d)
            return d;
        }

        function dline(s) {
            var d = $('<div>').addClass('imgcls-image-detail-line').html(s);
            d.prop('title', d.text())
            dcontent.append(d);
            return d;
        }

        if (isDetail) {
            // details.removeClass('imgcls-image-details')
            if (conf.annotationData && descriptor.userRole.role != 'nlp_an') {
                var c = conf.annotationData;
                if (descriptor.datasetMode) {
                    dtit('Item');
                    dval('ItemId', conf.itemId);
                    // dval('Avg. Consensus', c['Avg. Consensus']);
                    if (c.Tags && c.Tags.length) {
                        dval('Tags', c.Tags.map(t => {
                            var desc = gDataset.tags[t] && gDataset.tags[t].description || '';
                            return '<span class="imgcls-tag" title="' + desc + '">' + t + '</span>'
                        }).join(', '));
                        setTimeout(function () {
                            $('.imgcls-tag').on('click', function () {
                                var tag = $(this).text();
                                frm.myAlert('Tag: ' + tag, $(this).attr('title'), 'Ok')
                            })
                        }, 1)
                    }
                    if( modelRunFilter ) {
                        dtit('Predictions');
                        var llist = conf.prediction.filter( p => modelRunFilter[fix(p[0])] > 0 );
                        for( var l of llist ) {
                            dval( l[0], l[1].classification + ' ('+l[1].confidence+')')
                        }
                    }
                    // alert( project )
                    if (c.tasks && c.tasks.length && project) {
                        dtit('Project');
                        // dval('Label', c.Labels.join(', '));
                        c.tasks.forEach(l => {
                            if (l.project != project) return;
                            var labs = [];
                            for (var tl of l.trail) {
                                var lab = tl.classification || '';
                                if (tl.role == 'nlp_qc') lab = '<span class="imgcls-lab-review">' + lab + '</span>';
                                if (tl.role == 'c_super') lab = '<span class="imgcls-lab-super-review">' + lab + '</span>';
                                labs.push(lab)
                            }
                            if (labs.length) dval(l.projectName, labs.join(', '))
                        })
                    }
                    // console.log( 'PREVIEW', conf.preview )
                    if( conf.preview ) {
                        dtit('Preview');
                        dline(conf.preview )
                    }
                }
                else {
                    if (!descriptor.datasetMode) {
                        dtit('Task');
                        if (conf.fileId) dval('TaskId', conf.fileId)
                        if (defined(conf.annotationData.Consensus)) dval('Consensus', conf.annotationData.Consensus)
                        if (c['Final Label'] && c['Final Label'] != 'not labeled') {
                            let s = c['Final Label']
                            if (descriptor.adminEdit) s += ' <button class="force-label" fileId="' + conf.fileId + '" href="#">force new label</button>';
                            dval('Final Label', s);
                        }
                        dval('State', c.State);
                    }
                    if (descriptor.projectMode) {
                        if (c.Tags && c.Tags.length) {
                            dval('Tags', c.Tags.map(t => {
                                var desc = gProject.tags[t] && gProject.tags[t].description || '';
                                return '<span class="imgcls-tag" title="' + desc + '">' + t + '</span>'
                            }).join(', '));
                            setTimeout(function () {
                                $('.imgcls-tag').on('click', function () {
                                    var tag = $(this).text();
                                    frm.myAlert('Tag: ' + tag, $(this).attr('title'), 'Ok')
                                })
                            }, 1)
                        }
                    }
                    // dval('Annotations', c.annotations );
                    if (1 || descriptor.userRole.role == 'admin') {
                        for (var t of c.trail) {
                            if (filteredEmail && !filteredEmail[t.email]) continue;
                            let l = t.label;
                            if (t.reason) l += ' (' + t.reason + ')'
                            dval(t.email + ' (' + t.role + ')', l)
                        }
                        // if( c.Labels.length ) dval('Labels', c.Labels.join(', '));
                        if (c.Annotator.length && !descriptor.trainingType) dval('Annotators', c.Annotator.join(', '))
                        if (c.Reviewer.length && !descriptor.trainingType) dval('Reviewer', c.Reviewer.join(', '))
                    }
                    else {
                        for (var t of c.trail) {
                            dval(t.role, t.label)
                        }
                    }
                }
            }
            if (conf.metadata) {
                dtit('Metadata');
                for (var k in conf.metadata) dval(k, conf.metadata[k])
            }
        }
        else {
            if (descriptor.trainingType) {
                dline(conf.finalClassification);
            }
            else if (conf.annotationData && descriptor.userRole.role != 'nlp_an') {
                var c = conf.annotationData;
                // dval('Annotations', c.annotations );
                // c.Labels.forEach( l => dline(l) )

                // console.log( 'modelRunFilter',modelRunFilter, projectFilter )
                var labs = [];
                if (descriptor.datasetMode) {
                    
                    if( modelRunFilter ) {
                        var llist = [];
                        if( conf.prediction ) {
                            var llist = conf.prediction.filter( p => modelRunFilter[fix(p[0])] > 0 ).map( l => {
                                // console.log( 'LLLLLLLLLLLLLLLL', l )
                                let pred = l[1];
                                if( !pred ) return '(invalid response from model)'
                                if( pred.labels ) {
                                    return pred.labels.join(', ');
                                }
                                return pred.classification + ' (' + pred.confidence + ')'
                            } )
                        }
                        if( projectFilter ) {
                            var t = conf.tasks.find( t => fix(t.projectName) == projectFilter );
                            if( t ) {
                                if( t.labels ) {
                                    llist.push( t.labels.join(', '))
                                }
                                else {
                                    llist.push( t.classification || '' )
                                }
                            }
                        }
                        for( var l of llist ) {
                            dline( l );
                        }
                        // console.log( 'conf', llist ) 
                    } else {
                        // if (c.state != 0) dval('State', c.state + '<span class="state_' + c.state + '">' + c.State + '</span>');
                        dline('<span class="state_' + c.state + '">' + c.State + '</span>');
                        let labs = c.Labels;
                        if( projectFilter ) {
                            labs = [];
                            var t = conf.tasks.find( t => fix(t.projectName) == projectFilter );
                            if( t ) {
                                if( t.labels ) {
                                    labs.push( t.labels.join(', '))
                                }
                                else {
                                    labs.push( t.classification || '' )
                                }
                            }
                        }
                        // console.log( 'PPPPPPPPPPPPPPPPPPPPPPPPPP', projectFilter, labs )

                        var d = dline(labs.filter(l => l != 'null' && l != 'not classified').join(', '))
                        d.removeClass('imgcls-image-detail-line').addClass('imgcls-image-detail-line2')
                    }
                }
                else {
                    if (descriptor.userRole.role == 'admin' && !descriptor.ddatasetMode)
                        // dval('State', '<span class="state_'+c.state+'">'+c.State+'</span>' );
                        dline('<span class="state_' + c.state + '">' + c.State + '</span>');
                    c.trail.forEach(l => {
                        var lab = l.label;
                        if (l.role == 'R.') lab = '<span class="imgcls-lab-review">' + lab + '</span>';
                        if (l.role == 'S.') lab = '<span class="imgcls-lab-super-review">' + lab + '</span>';
                        labs.push(lab)
                    })
                    if (labs.length) {
                        var d = dline(labs.join(', '))
                        // dline('&nbsp;')
                        d.removeClass('imgcls-image-detail-line').addClass('imgcls-image-detail-line2')
                    }
                    else {
                        dline('&nbsp;').removeClass('imgcls-image-detail-line').addClass('imgcls-image-detail-line2')
                    }
                }
            }
            else if (descriptor.qualificationMode == 1 && descriptor.userRole.role == 'nlp_an') {
                var cls = conf.finalClassification || ''
                if (conf.classification != labelUnclassified && conf.classification != conf.finalClassification)
                    cls = '<span class="imgcls-lab-review">' + cls + '</span>'
                // console.log('CLS', cls)
                dline(cls)
            }
        }
        detWrapper.append(details);
    }

    if (scontrol && isDetail) {
        var sliders = $('<div>').addClass('imgcls-image-controls ');
        detWrapper.append(sliders)
        
        if (descriptor.imageControls.redAdjust) addSlider(sliders, { label: 'R', min: 0, max: 2, reset: 1, ini: roff, labelWidth: labelWidth, width: '100%' }, function (v) {
            roff = conf.redOffset = v;
            imageLastTouched = iid;
            adjustColor();
            setImage(conf)
        });
        if (descriptor.imageControls.greenAdjust) addSlider(sliders, { label: 'G', min: 0, max: 2, reset: 1, ini: goff, labelWidth: labelWidth, width: '100%' }, function (v) {
            goff = conf.greenOffset = v;
            imageLastTouched = iid;
            adjustColor();
            setImage(conf)
        });
        if (descriptor.imageControls.blueAdjust) addSlider(sliders, { label: 'B', min: 0, max: 2, reset: 1, ini: boff, labelWidth: labelWidth, width: '100%' }, function (v) {
            boff = conf.blueOffset = v;
            imageLastTouched = iid;
            adjustColor();
            setImage(conf)
        });
        if (descriptor.imageControls.brigtnessAdjust) addSlider(sliders, { label: '<i class="fa fa-sun-o"></i>', min: 0, max: 2, reset: 1, ini: brightness, labelWidth: labelWidth, width: '100%' }, function (v) {
            if (v > 1) v = (v - 1) * 2 + 1;
            brightness = conf.brightness = v;
            imageLastTouched = iid;
            adjustColor();
            setImage(conf)
        });
    }
    adjustColor();

    function fval(r, g, b) {
        return '<feColorMatrix type="matrix" values="' + r * brightness + ' 0.00 0.00 0.00 0.00 0.00 ' + g * brightness + ' 0.00 0.00 0.00 0.00 0.00 ' + b * brightness + ' 0.00 0.00 0.00 0.00 0.00 1.00 0.00"></feColorMatrix>';
    }
    function adjustColor() {
        // console.log( fid, roff, goff, fval(roff,goff,boff) )
        $('#' + fid).html(fval(roff, goff, boff))
    }

    function multiSelect(start, end, sel, callback ) {
        var missing = false;
        if( end < start ) [end,start] = [start,end];
        for( var i = start ; i <= end ; i++ ) {
            var img = filteredImages[i];
            if( !img[imgKey] ) {
                missing = true;
                break;
            }
            img.selected = sel;
            if( sel ) gSelected[img[imgKey]] = 1;
            else delete gSelected[img[imgKey]];
            setImage(img);
        }
        if (missing) {
            var ftr = qFilter();
            ftr._project = imgKey;
            frm.loading('Selecting')
            descriptor.progressiveLoad({
                start: start,
                end: end,
                filter: ftr,
                noLoading: true,
            }, res => {
                console.log('MULTI', start, end, res)
                frm.loadingOut();
                var j = 0;
                for (var i = 0; i < res.length; i++) {
                    var img = filteredImages[i + start] 
                    // if( img[imgKey] != res[i] ) console.log( 'keys dont match', i, img[imgKey], res[i] )
                    img[imgKey] = res[i];
                }
                multiSelect(start, end, sel, callback)
                // initImageList();
                // // for( var i = 0 ; i < res.length ; i++ ) {
                // //     var img = res[i];
                // //     imageList[i] = img;
                // //     img.id = i;
                // //     descriptor.dataset[i] = img;
                // // }
                // mkAnnotationData();
                // filterVisible(() => {
                //     draw(scrolTop);
                // });
            });
            console.log('MULTISELECT MISSING', start, end, imgKey );
        }
        else callback();
    }

    function select(ev) {
        if( ev.ctrlKey ) {
            let clip = conf.fileId;
            let msg = 'TaskId saved to Clipboard'
            if( !clip && conf.itemId ) {
                clip = conf.itemId;
                msg = 'ItemId saved to Clipboard'
            }
            frm.saveClipboard( clip )
            frm.myAlert('Metadata Copied', msg, 'Ok')
            setTimeout( function(){
                $("#modal-close")[0].click();
            }, 3000  )
            return;
        }
        if (imgClick) return dblClick(ev);
        imgClick = true;
        rolloverDetailOut(true)
        if (!conf.selected) cont();
        else {
            imgClickTid = setTimeout(cont, 250)
        }
        setTimeout(function () { imgClick = false; }, 250);
        function cont() {
            if (imageClicked !== null && ev.shiftKey) {
                var sstart = filteredImages.findIndex(f => f.id == imageClicked);
                var send = filteredImages.findIndex(f => f.id == conf.id);
                var sel = filteredImages[sstart].selected;
                if (send < sstart) [sstart, send] = [send, sstart];
                // console.log( 'SHIFT', imageClicked, 's', sstart, 'e', send );

                multiSelect( sstart, send, sel, () => {
                    // for (var i = sstart; i <= send; i++) {
                    //     filteredImages[i].selected = sel;
                    //     setImage(filteredImages[i]);

                    // }
                    draw();
                    actionCheck();
                })
            }
            else doSelect()
        }
    }

    function doSelect(noaction) {
        if (descriptor.selectionMode.match(/single/i)) {
            // console.log( 'SINGLE')
            for (var i of filteredImages) {
                // console.log( i.id, conf.id, i.selected )
                if (i.id != conf.id && i.selected) {
                    delete i.selected;
                    delete gSelected[i[imgKey]]
                }
            }
            $('.imgcls-image-selected').removeClass('imgcls-image-selected')
        }
        // imgClick = false;
        if (!noaction && descriptor.imageLayout.click) descriptor.imageLayout.click(conf)
        cell.removeClass('imgcls-image-selected');
        conf.selected = !conf.selected;
        if( conf.selected ) gSelected[conf[imgKey]] = 1;
        else delete gSelected[conf[imgKey]];
        if (conf.selected) cell.addClass('imgcls-image-selected');
        // console.log( $(this)[0], $(this).prop('imageid') )
        if (!noaction) countSelected();
        imageLastTouched = iid;
        imageClicked = conf.id;
        if (conf.selected && descriptor.detailLayout.policy == 'click' && !noaction) showDetail();
        if (!conf.selected && conf.id == detailSelected) hideDetail();
        setImage(conf)
        actionCheck();
    }

    async function showDetail() {
        hideDetail();
        if( descriptor.detailLayout.customDetail && await descriptor.detailLayout.customDetail( conf, project, qFilter(), filters ) ) return;
        detailSelected = conf.id;

        var idx = filteredImages.findIndex(i => i.id == conf.id)
        var ins = Math.floor(idx / imageZoom) * imageZoom + imageZoom;
        if (ins < filteredImages.length) {
            var before = $('#image_' + filteredImages[ins].id);
            if (!before.length) before = 1;
        }
        else var before = 1;
        $('.imgcls-image-container-detail').remove();
        $('#image_' + conf.id).addClass('imgcls-detail-selected');
        var dimg = addImage(hook, conf, before)
        var el = dimg.element;
        var size = zoomSize()+30;
        var awidth = $('.imgcls-browse').width();
        var conwidth = awidth-30;
        size = conwidth/4;
        // el.addClass('imgcls-detail-selected').addClass('imgcls-image-container-detail').css({ width: size * imageZoom -30 });
        el.addClass('imgcls-detail-selected').addClass('imgcls-image-container-detail').css({ width: conwidth });
        el.find('.imgcls-image-box').css({ width: size, height: size })
        // el.find('.imgcls-image-wrapper').css({width: size*4})
        el.find('.imgcls-image-wrapper').css({ width: 'auto' })
        el.find('.imgcls-image-detail-wrapper').css({ ddisplay: 'table-cell', width: conwidth-size-30, height: size-30 })
    }

    function dblClick(ev) {
        imgClick = false;
        clearTimeout(imgClickTid)
        // console.log( 'double click' )
        imageLastTouched = iid;
        if (descriptor.detailLayout.policy == 'doubleclick') showDetail();
    }

    if (!isDetail) cell.on('click', select)

    function adjust() {
        adjustColor();
    }

    img.css({ filter: 'url(#' + fid + ')' });
    if (before) before.before(cell);
    else hook.append(cell);
    var obj = {
        element: cell,
        conf: conf,
        adjust: adjust,
        doSelect: doSelect,
    }
    conf.adjust = adjust;
    conf.xxx = 1;

    function forceLabel() {
        var forced = false;
        function force(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            frm.removeInlineErrors();
            if (forced) return;
            // if (!newLabel) return $('.force-error').html('Select the new label');
            if (!newLabel) return frm.inlineError( $('.new-forced-label'), 'Select the new label');
            var reason = $('.force-reason').val().trim();
            if (!reason) {
                setTimeout(function () {
                    $('.force-reason')[0].focus();
                }, 100)
                return frm.inlineError( $('.force-reason'), 'Inform the reason for the label change');
                // return $('.force-error').html('Inform the reason for the label change');
            }
            forced = true;
            // console.log( 'fileId', fileId, 'newLabel', newLabel, 'reason', reason )
            window.post('force_new_label', { fileId: fileId, newLabel: newLabel, reason: reason }, res => {
                var data = res.data;
                // console.log( 'RESULT', data )
                conf.taskAnnotations.push(data.annotation);
                conf.finalClassification = data.classification;
                conf.state = data.state;
                conf.qcEmail = data.qcEmail;
                conf.selected = false;
                delete gSelected[conf[imgKey]]
                setFilters()
                frm.myAlertClose(function () {
                    filterVisible(draw);
                    descriptor.dashboardUpdate();
                })
            })
        }
        var fileId = $(this).attr('fileId');
        var newLabel = null;
        // console.log( 'forceLabel', $(this).attr('fileId') );
        frm.myAlert('Force new label', '<div class="force-container"><div class="force-error alert-error"></div><div class="new-forced-label"></div><textarea type="text" placeholder="Enter Reason For Label Change" class="force-reason form-control"></textarea></div>', 'Force new label', force, 'Cancel')
        $('.force-container').css({ height: 300 })
        $('.force-reason').css({ height: 200 })
        var keys = descriptor.labels.map(l => l.label);
        keys.unshift({ value: 'exclude', label: '<span class="state_5">Exclude and Reject</span>' })
        keys.unshift({ value: '', label: 'Clear All' }) // modify label :&nbsp; as clear All mani
        // console.log( 'LABELKEYS', keys )
        frm.dropDown($('.new-forced-label'), keys, '', { placeholder: 'Select New Label', width: '100%' }, function (v) {
            newLabel = v;
        });
    }

    cell.find('.force-label').on('click', forceLabel)

    return obj;
}

function listActions(hook, labels, selected, baseClass, callback) {
    var maxDisplay = 100;
    var hookMargins = parseInt(hook.css('margin-left'))+parseInt(hook.css('margin-right'))
    var maxWidth = $('.maincontent').width()-5-hookMargins;

    hook.css({ display: 'inline-block' })
    hook.find('.label-button').remove();
    var display = [];
    var popup = [];
    if( baseClass == 'imgcls-classify-label' ) labels = labels.map( l => { return {label:l.label}} );
    // console.log('listActions',hook, labels, selected, baseClass )
    for (var l of labels) {
        if (display.length < maxDisplay) display.push(l);
        else {
            if (l.label == selected) {
                var last = display.pop();
                popup.unshift(last);
                display.push(l);
            }
            else popup.push(l);
        }
    }
    if (popup.length == 1) {
        display.push(popup.pop());
    }
    if (popup.length) {
        display.push({ label: '...', popup: true })
    }
    let buttons = [];
    function addBtn( l, pop ) {
        var lbutton = $('<button>').addClass('label-button');
        if( pop ) lbutton.addClass('label-button-popup');
        if( !pop ) buttons.push( lbutton );
        var txt = l.label;
        if ('count' in l) txt += '<span class="imgcls-count"> (' + l.count + ')</span>';
        lbutton.html(txt);
        lbutton.addClass(baseClass);
        if (l.label == selected) lbutton.addClass(baseClass + '-selected');
        lbutton.prop('label', l);
        hook.append(lbutton);
        if (l.popup) {
            lbutton.on('click', popupOptions);
            return;
        }
        lbutton.on('click', function (ev) {
            callback($(this).prop('label'));
        })
    }
    for (var l of display) {
        addBtn( l );
    }

    let max = 50;
    // console.log( 'WIDTHCHECK', hook.width(), maxWidth, 'start', selected )
    while( hook.width() >= maxWidth && max-- >= 0 ) {
        // console.log( 'WIDTHCHECK', hook.width(), maxWidth, display.length )
        if( hook.find('.label-button-popup').length )
            hook.find('.label-button-popup').remove();
        let dpop = null;
        let bpop = null;
        for (let i = display.length - 1; i >= 0; i--) {
            if (display[i].label == selected) continue;
            dpop = display.splice(i, 1)[0];
            bpop = buttons.splice(i, 1)[0];
            break;
        }
        // console.log( 'dpop', dpop )
        if( dpop ) {
            bpop.remove();
            popup.unshift( dpop );
        }
        addBtn( { label: '...', popup: true }, true ); // add popup btn
    }


    function popupOut() {
        eventOutsideEnd();
        $('.imgcls-label-popup').remove();
    }
    function popupOptions(ev) {
        if ($('.imgcls-label-popup').length) return popupOut();
        var position = $(this).offset();
        var top = position.top + $(this).outerHeight();
        var right = position.left + $(this).outerWidth();
        // console.log('position', position, this, top, right)
        // var 

        var pop = $('<div>').addClass('imgcls-label-popup');
        $(document.body).append(pop);
        pop.css({ position: 'absolute', top: top, left: right - pop.outerWidth() });
        eventOutsideEnd();
        eventOutside(pop, 'mousedown', popupOut);
        for (var l of popup) {
            var lbutton = $('<button>').addClass(baseClass)
            var txt = l.label;
            if ('count' in l) txt += '<span class="imgcls-count"> (' + l.count + ')</span>';
            lbutton.html(txt);
            lbutton.prop('label', l);
            pop.append(lbutton);
            lbutton.on('click', function (ev) {
                popupOut()
                let selected = $(this).prop('label');
                callback( selected );
            })
        }
    }
}

function listActionsOld(hook, labels, selected, baseClass, callback) {
    var maxDisplay = 6;
    var maxWidth = $('.maincontent').width();

    hook.css({ display: 'inline-block' })
    hook.find('.label-button').remove();
    var display = [];
    var popup = [];
    if( baseClass == 'imgcls-classify-label' ) labels = labels.map( l => { return {label:l.label}} );
    console.log('listActions',hook, labels, selected, baseClass )
    for (var l of labels) {
        if (display.length < maxDisplay) display.push(l);
        else {
            if (l.label == selected) {
                var last = display.pop();
                popup.unshift(last);
                display.push(l);
            }
            else popup.push(l);
        }
    }
    if (popup.length == 1) {
        display.push(popup.pop());
    }
    if (popup.length) {
        display.push({ label: '...', popup: true })
    }
    for (var l of display) {
        var lbutton = $('<button>').addClass('label-button');
        var txt = l.label;
        if ('count' in l) txt += '<span class="imgcls-count"> (' + l.count + ')</span>';
        lbutton.html(txt);
        lbutton.addClass(baseClass);
        if (l.label == selected) lbutton.addClass(baseClass + '-selected');
        lbutton.prop('label', l);
        hook.append(lbutton);
        if (l.popup) {
            lbutton.on('click', popupOptions);
            return;
        }
        lbutton.on('click', function (ev) {
            callback($(this).prop('label'));
        })
    }

    function popupOut() {
        eventOutsideEnd();
        $('.imgcls-label-popup').remove();
    }
    function popupOptions(ev) {
        if ($('.imgcls-label-popup').length) return popupOut();
        var position = $(this).offset();
        var top = position.top + $(this).outerHeight();
        var right = position.left + $(this).outerWidth();
        // console.log('position', position, this, top, right)
        // var 

        var pop = $('<div>').addClass('imgcls-label-popup');
        $(document.body).append(pop);
        pop.css({ position: 'absolute', top: top, left: right - pop.outerWidth() });
        eventOutsideEnd();
        eventOutside(pop, 'mousedown', popupOut);
        for (var l of popup) {
            var lbutton = $('<button>').addClass(baseClass)
            var txt = l.label;
            if ('count' in l) txt += '<span class="imgcls-count"> (' + l.count + ')</span>';
            lbutton.html(txt);
            lbutton.prop('label', l);
            pop.append(lbutton);
            lbutton.on('click', function (ev) {
                popupOut()
                callback($(this).prop('label'));
            })
        }
    }
}


function totalItems() {
    var tot = imageList.length;
    var fter = filteredImages.length;
    var ret = fter < tot ? 'Total filtered items: <b>' + fter + '</b>' : 'Total items: <b>' + tot + '</b>'
    ret += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
    return ret;
}

function paginationOut() {
    // $('.imgcls-toolbar-nav-placeholder').hide();
    // $('.imgcls-toolbar-nav').hide();
    $('.imgcls-toolbar-nav-placeholder').show();
    var pags = $('.imgcls-toolbar-nav').show();
    pags.addClass('unselectable');

    pags.html('<div class="imgcls-toolbar-nav-title">' + totalItems() + '&nbsp;</div>');
}

function pagination(page, rows) {
    var totPages = Math.ceil(rows.length / itemsPerPage);
    $('.imgcls-toolbar-nav-placeholder').show();
    var pags = $('.imgcls-toolbar-nav').show();
    pags.addClass('unselectable');

    pags.html('<div class="imgcls-toolbar-nav-title"></div>');
    // var pfirst = $('<li className="page-item page-first">');
    // pfirst.html('<a class="page-link" href="#" aria-label="Previous" idx="0"><span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span></a>');
    // pags.append(pfirst);
    // var range = 8;
    // var pini = page - range / 2;
    // var pfim = page + range / 2;
    // if (pini < 0) pini = 0;
    // if (pfim - pini < range) pfim = pini + range;
    // if (pfim > totPages - 1) pfim = totPages - 1;
    // if (pfim - pini < range) pini = pfim - range;
    // if (pini < 0) pini = 0;
    // // console.log( 'pagination', pags[0], 'page', page, 'pini', pini, 'pfim', pfim, totPages );
    // for (var p = pini; p <= pfim; p++) {
    //     var ppp = p + 1;
    //     var pnum = $('<li class="page-item page-number"><a class="page-link" href="#" idx="' + p + '">' + ppp + '</a></li>');
    //     if (p == page) pnum.addClass('active');
    //     pags.append(pnum);
    // }
    // var plast = $('<li className="page-item page-last">');
    // plast.html('<a class="page-link" href="#" aria-label="Next" idx="-1"><span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span></a>');
    // pags.append(plast);
    $('.page-link').off('click').on('click', function (ev) {

        var to = $(this).attr('idx');
        if (to == -1) to = totPages - 1;
        // console.log( 'to page', to );
        currentPage = to * 1;
        draw(1);
        ev.preventDefault();
        ev.stopPropagation();
    })

    function pagCb( n ) {
        currentPage = n-1;
        draw(1);
    }

    // $('.imgcls-toolbar-nav-title').html(totalItems() + 'Page ' + (currentPage + 1) + ' of ' + totPages)
    $('.imgcls-toolbar-nav-title').html(totalItems() )
    frm.paginator( $('.imgcls-toolbar-nav-title'), currentPage+1, totPages, pagCb  )

    // var filterTxt = '<nobr>';
    // var fkeys = Object.keys(filters);
    // var i1 = (dc.page)*dc.pageSize;
    // var i2 = (dc.page+1)*dc.pageSize-1; if( i2 >= me.baseRows.length ) i2 = me.baseRows.length-1;
    // // console.log( 'pini', pini, 'pfim', pfim, 'psize', dc.pageSize, i1, i2 )

    // var items = me.baseRows.length == 1 ? 'item' : 'items';
    // if( pini == pfim )
    // {
    //     pags.find('li').hide();
    //     filterTxt = '<b>Total ';
    // }
    // else filterTxt = '<b>' + (i1+1) + ' - ' + (i2+1) + ' of ';
    // if( fkeys && me.baseRows.length < me.rows.length )
    // {
    //     if( pini == pfim ) filterTxt = '<b>';

    //     var fnames = fkeys.map( f => '<a href="#" col="'+f+'">' + dc.columns[f] + '<span> <i class="fa fa-close"></i></span></a>');
    //     filterTxt += '' + me.baseRows.length + '</b> '+ items +' filtered from a total of '+ me.rows.length +' <i>('+fnames.join(', ')+')</i>';
    // }
    // else {
    //     filterTxt += '' + me.rows.length + '</b>';
    // }
    // filterTxt += '</nobr>';
    // pags.find('.imgcls-toolbar-nav-title').html(filterTxt).find('a').on('click', function(ev){
    //     var rfilter = $(this).attr('col');
    //     delete filters[rfilter];
    //     me.update = true;
    //     me.draw();
    //     saveContext();
    //     // alert( rfilter );
    //     ev.preventDefault();
    //     ev.stopPropagation();
    // });
}

function hideDetail() {
    detailSelected = null;
    $('.imgcls-detail-selected').removeClass('imgcls-detail-selected')
    $('.imgcls-image-container-detail').remove()
}



function drawTabs() {
    // return;
    hideDetail();
    var classifyLabels = clone(descriptor.labels);
    $('.imgcls-toolbar-buttons').show()
    $('.imgcls-toolbar-buttons-placeholder').show()
    listActions($('.imgcls-toolbar-buttons'), classifyLabels, null, 'imgcls-classify-label', function (v) {
        var reindex = [];
        for (var i of imageList) {
            if (i.classification == selectedTab && i.selected) {
                reindex.push( i.fileId );
                i.selected = false;
                delete gSelected[i[imgKey]]
                i.classification = v.label;
                setImage(i, true)
            }
        }
        filterVisible(function(){
            draw();
            // console.log( 'reindex', reindex )
            // window.post('index_tasks', {fileId:{$in:reindex}}, function(){
            //     queryFilter = true;
            //     // console.log( 'indexed');
            //     setTimeout( draw, 100 )
            // } )
        });
    })
    classifyLabels.unshift({
        label: labelUnclassified,
    });
    var labCount = {};
    for (var l of classifyLabels) labCount[l.label] = 0;
    function add(l) { if (!(l in labCount)) labCount[l] = 0; labCount[l]++ }
    for (var img of imageList) {
        // if (!img.filterPass) continue;
        var cls = img.classification || labelUnclassified;
        add(cls);
    }
    for (var l of classifyLabels) {
        l.count = labCount[l.label];
    }
    // console.log( 'labCount', labCount, classifyLabels )
    listActions($('.imgcls-toolbar-tabs'), classifyLabels, selectedTab, 'imgcls-classify-tab', function (v) {
        selectedTab = v.label;
        currentPage = 0;
        filterVisible(draw);
    })
}


var filteredImages = [];
function filterVisible(callback) {
    ckModelRunFilter();
    // filteredImages = imageList;
    // return callback();
    window.filteredImages = filteredImages = [];
    // console.log( 'imageList', imageList )
    for (var img of imageList) {
        if (descriptor.classificationMode && img.classification != selectedTab) continue;
        filteredImages.push(img);
    }
    return callback();

}

var filterConfig = { _all: {} }
var filterType = {};


function mkFilterData() {
    var filter = clone(descriptor.filterData);
    delete filter._ts;
    window.filterType = filterType = filter._filterType || {};
    delete filter._filterType;
    var keys = Object.keys(filter).sort( (a,b) => (a).toString().toLowerCase() < (b).toString().toLowerCase() ? -1 : 1);
    window.filterConfig = filterConfig = {};
    // console.log('KEYS', keys, filter  )
    var ignoreKeys = {};
    var ik = [];
    ckFilterGlobal()
    if (descriptor.userRole.role == 'nlp_an') {
        var ik = [
            "Annotations",
            "Annotator",
            "Reviewer",
            "Consensus",
            "Dataset",
            "Dataset Id",
            "Final Label",
            "Training Label",
            "Labels",
            "File Name",
            "Project",
            "Project Id",
            "State",
            "TaskId",
            "Training",
            "Training Label",
            "Type",
            "Model Run",
            "Prediction",
        ]
    }
    if (descriptor.userRole.role == 'nlp_qc') {
        var ik = [
            "Reviewer",
            "Final Label",
            "Training Label",
            "Model Run",
            "Prediction",
        ]
    }
    for( var i of ik ) ignoreKeys[i] = 1;
    // console.log( 'ignoreKeys', ignoreKeys )
    for( var k of keys ) {
        if( ignoreKeys[k] ) {
            delete filterConfig[k];
            // console.log( 'IGNORE', k )
            continue;
        }
        // console.log( 'k', k, 'filterConfig', filterConfig, 'filter', filter  )
        filterConfig[k] = filter[k] || []
        // console.log( 'k', k )
        // if( filter[k] && filter[k].length < 2 && k != 'State' && k != 'Model Run' && k != 'Dataset Type' ) filterType[k] = -1;
    }
    console.log( 'filterConfig', filterConfig)
    $('.imgcls-toolbar-project').hide().html('');

    if( descriptor.datasetMode && !descriptor.compareMode ) {
        filterType.Project = -1;

        let m = clone(descriptor.baseMatch.match);
        delete m.compare;
        window.post( 'dataset_projects', {match:m}, res => {
            var projectNames = res.data;
            var prj = Object.keys(projectNames)
            if (prj.length) {
                // console.log( 'PROJECT', projects )
                var fproj = $('<div>')
                if (!descriptor.configLock) $('.imgcls-toolbar-project').html('').show().append(fproj);
                fproj.html('<div class="imgcls-title">GroundTruth</div>');
                var keys = prj.map(t => { return { value: t, label: projectNames[t] } })
                keys.unshift({ value: '', label: 'Clear All' }); // modify &nbsp; to Clear All 30/12 mani
                function setProjectFilter( v ) {
                    if( v != '' ) {
                        var f = filters.find( ft => ft.key == 'Project' );
                        if( !f ) {
                            f = {key: 'Project', value: fix(projectNames[project]), type: 0, fid: filters.length+1, value2: ''}
                            console.log( 'FFFFFFFFFFFFF', f, projectNames[project] )
                            filters.push(f);
                        }
                        f.value = fix(projectNames[project]);
                    }
                    else {
                        window.filters = filters = filters.filter( ft => ft.key != 'Project')
                    }
                    return f;
                }
                groundtruthProject = project;
                window.groundtruthProject = project;
                var pkeys = frm.dropDown(fproj, keys, project, { width: 180, placeholder: 'select project' }, function (v) {
                    if (v != project) {
                        console.log( 'VVVVVVVVVVVVVVVVV', v, 'proje', project )
                        project = v;
                        groundtruthProject = v;
                        window.groundtruthProject = v;
                        if( pkeys && pkeys.is(':visible') ) setProjectFilter( v );
                        // if( v != '' ) {
                        //     var f = filters.find( ft => ft.key == 'Project' );
                        //     if( !f ) {
                        //         f = {key: 'Project', value: fix(projectNames[project]), type: 0, fid: filters.length+1, value2: ''}
                        //         console.log( 'FFFFFFFFFFFFF', f, projectNames[project] )
                        //         filters.push(f);                 
                        //     }
                        //     f.value = fix(projectNames[project]);
                        // }
                        // else window.filters = filters = filters.filter( ft => ft.key != 'Project')
                        // redraw();
                        setFilters();
                        filterVisible(draw)
                        saveConfig();
                    }
                }).addClass('imgcls-dropdown-value'); // modify imgcls-dropdown-key to imgcls-dropdown-value 30/12 mani
                projectSelector = pkeys;
                ckModelRun();
            }
        })
    }
    else if( descriptor.compareMode ) {
        try {
            for (let c of descriptor.baseMatch.match.compare) {
                if (c.tasks) {
                    project = groundtruthProject = window.groundtruthProject = c.tasks.$elemMatch.project;
                }
            }
        }
        catch (e) { console.error(e) }
    }
}

function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-\:\/]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }
// function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }

function mkFilterDataOld() {
    filterConfig = { _all: {} }
    filterType = {};
    var filterIgnore = { 'Cloned from': 1 }
    function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-\:\/]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }
    // function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }

    function add(f, k, v) {
        if (!defined(v)) return;
        // console.log( 'add', f, k, v )
        if (!f[k]) f[k] = {};
        v = fix(v);
        f[k][v] = 1;
        // f._all[v] = 1;
    }
    var noLower = true;
    function walk(o, klist) {
        if (isobj(o)) {
            for (var k in o) {
                walk(o[k], klist.concat([k]));
            }
        }
        else if (isarray(o)) {
            var k = klist.join('.');
            for (var v of o) {
                add(filterConfig, k, v);
                add(i.filter, k, v);
            }
        }
        else {
            var k = klist.join('.');
            if (!k.match(/^[A-Z]/) && noLower) return;
            if (filterIgnore[k]) return;
            add(filterConfig, k, o);
            add(i.filter, k, o);
        }
    }
    for (var i of imageList) {
        i.filter = { _all: {} };
        if (i.annotationData) walk(i.annotationData, [])
        noLower = false;
        if (i.metadata) walk(i.metadata, [])
        add(filterConfig, 'File Name', i.label)
        add(i.filter, 'File Name', i.label)
    }
    // check the filter types.If all keys are numeric, then make it a range filter
    var _all = filterConfig._all;
    delete filterConfig._all;
    delete filterConfig.projects;

    var del = [];
    for (var k in filterConfig) {
        filterType[k] = 0;
        var isNum = true;
        var count = 0;
        for (var kk in filterConfig[k]) {
            if (kk != 'none' && (isNaN(parseInt(kk)) || kk.match(/[a-z@_]/i))) isNum = false;
            count++;
        }
        // console.log('key', k, isNum)
        if (!isNum) {
            for (var kk in filterConfig[k]) {
                _all[kk] = 1;
            }
        }
        else {
            filterType[k] = 1;
            // filterConfig[k] = Object.keys(filterConfig[k]).map(v => v == 'none' ? v : v * 1).sort((a, b) => {
            //     if (a == 'none') a = 0;
            //     if (b == 'none') b = 0;
            //     return a < b ? -1 : 1;
            // });
            filterConfig[k] = Object.keys(filterConfig[k]).sort((a, b) => {
                if (a == 'none') a = 0;
                if (b == 'none') b = 0;
                a *= 1; b *= 1;
                return a < b ? -1 : 1;
            });
        }
        if (count == 1 && k != 'Tags') {
            // console.log('DELETE', k)
            del.push(k);
        }
    }
    for (var d of del) {
        delete filterConfig[d];
        for (var i of imageList) delete i.filter[d];
    }

    $('.imgcls-toolbar-project').hide().html('');

    var prj = Object.keys(projects)
    if (prj.length) {
        // console.log( 'PROJECT', projects )
        var fproj = $('<div>')
        if (!descriptor.configLock) $('.imgcls-toolbar-project').show().append(fproj);

        fproj.html('<div class="imgcls-title">Project</div>');
        var keys = prj.map(t => { return { value: projects[t], label: t } })
        keys.unshift({ value: '', label: 'Clear All' });
        var pkeys = frm.dropDown(fproj, keys, project, { width: 210, placeholder: 'Select Project' }, function (v) {
            if (v != project) {
                project = v;
                // redraw();
                setFilters();
                filterVisible(draw)
                saveConfig();
            }
        }).addClass('imgcls-dropdown-value'); // modify imgcls-dropdown-key to imgcls-dropdown-value 21/07 mani
    }

    var _all = {};
    for (var k in filterConfig) {
        if (!isarray(filterConfig[k])) {
            for (var kk in filterConfig[k]) {
                _all[kk] = 1;
            }
        }
    }
    filterConfig._all = _all;

    for (var i of imageList) {
        var _all = {};
        for (var k in i.filter) {
            if (!filterType[k]) {
                var vlist = Object.keys(i.filter[k]);
                for (var v of vlist) _all[v] = 1;
            } else {
                i.filter[k] = Object.keys(i.filter[k])[0]
            }
        }
        i.filter._all = _all;
    }
    // console.log( 'filterConfig', JSON.stringify(filterConfig) )
    window.filterConfig = filterConfig;
}

function calcConsensus(trail) {
    if (descriptor.qualificationMode) return 'none';
    var winner = null;
    var counts = {};
    var labs = 0;
    var tcount = {};
    var ret = {};
    for (var t of trail) {

        var label = (t.annotations && t.annotations.classification) || t.classification || 'not labeled';
        // if (t.role == 'nlp_an') {
        if (t.role != 'training') {
                counts[label] = (counts[label] || 0) + 1;
            labs++;
        }
        tcount[t.role] = (tcount[t.role] || 0) + 1;
    }
    for (var k in counts) if (!winner || counts[k] > counts[winner]) winner = k;
    if (counts[winner] > 0 && labs > 1) {
        ret.Consensus = (counts[winner] / labs).toFixed(2);
    }
    else ret.Consensus = 0;
    ret.winner = winner;
    ret.counts = tcount;
    return ret;
}

function annotationData(i) {

    var role = {
        'nlp_an': 'A.',
        'nlp_qc': 'R.',
        'c_super': 'S.',
        'training': 'T.',
    }
    if( gSelected[i[imgKey]] ) i.selected = true;
    var adata = {};
    adata.Consensus = 'None';
    adata.Consensus = 0;
    adata['Final Label'] = i.finalClassification || 'not labeled';
    adata.State = window.stateLabels[i.state];
    if (adata.State == 'Unassigned' && descriptor.datasetMode) adata.State = 'Processed';
    adata.Annotations = 0;
    adata.Labels = [];
    adata.Annotator = i.userEmail || '';
    adata.Reviewer = i.qcEmail || '';
    adata.trail = [];
    // adata.state = i.state;
    var counts = {};
    var labs = 0;
    if (descriptor.datasetMode) {
        var conCt = 0;
        var conTot = 0;
        var pnames = {};
        var lCount = {};
        if (i.tasks) {
            for (var t of i.tasks) {
                pnames[t.project] = 1;
                projects[t.projectName] = t.project;
                // console.log( 'project', project, 't.project', t.project )
                if (!project || t.project != project) continue;
                lCount[t.classification] = 1;
                if (i.itemId == "9134e00b7108bab5659202c1") {
                    // console.log( 't.classification', t.classification, t.classification != 'exclude' && t.classification != 'not labeled' )
                }
                if (t.classification != 'exclude' && t.classification != 'not classified' && t.classification != 'not labeled') {
                    var c = calcConsensus(t.trail);
                    conCt++;
                    if (c.Consensus > 0) conTot += c.Consensus * 1;
                }
            }
            // adata['Avg. Consensus'] = conCt > 0 ? (conTot/conCt).toFixed(2)*1 : 'None';
        }
        // console.log( 'avg consensus', conCt, conTot)
        adata['Consensus'] = conCt > 0 ? (conTot / conCt).toFixed(2) * 1 : 0;
        adata.Tags = i.tags ? Object.keys(i.tags) : [];
        adata.Labels = Object.keys(lCount);
        var pn = Object.keys(pnames);
        adata.tasks = i.tasks;
        if (pn.length) {
            adata.projects = pn
            // adata['Num Projects'] = adata.Projects.length;
        }
        adata.ItemId = i.itemId;
    }
    else if (descriptor.userRole.role == 'admin') {
        adata.Tags = i.tags ? Object.keys(i.tags) : [];
    }
    if (i.taskAnnotations) {
        if (descriptor.userRole.role == 'nlp_qc') {
            i.taskAnnotations = i.taskAnnotations.filter(t => t.role != 'nlp_qc');
            adata.Reviewer = '';
        }
        for (var t of i.taskAnnotations) {
            adata.Labels.push(t.annotations.classification);
            var label = t.annotations.classification;
            adata.trail.push({
                email: t.email,
                label: label,
                role: role[t.role],
                reason: t.annotations.reason,
            })
            if (t.role == 'nlp_an') {
                if (!counts[label]) counts[label] = 0;
                counts[label]++;
                labs++;
            }
            adata.Annotations++;
        }
        var winner = null;
        for (var k in counts) if (!winner || counts[k] > counts[winner]) winner = k;
        if (counts[winner] > 0 && labs > 1) {
            adata.Consensus = (counts[winner] / labs).toFixed(2);
        }
        else adata.Consensus = 'None';
        // console.log( 'calcConsensus', calcConsensus(i.taskAnnotations)  )
    }
    if (i.fileId) adata.TaskId = i.fileId;
    return adata;
}

var stateLabels = null;

function mkAnnotationData(start,end) {
    if (descriptor.userRole.role == 'nlp_an') return;
    if( !start ) start = 0;
    if( !end ) end = imageList.length;
    for( var j = start ; j < end ; j++ ) {
        var i = imageList[j];
        if( !i.imageUrl ) continue;
        i.annotationData = annotationData(i);
    }
}

var filters = [];
var filterSnapshot = '';
var queryFilter = false;
var sortIndex = null;
var sortDir = 1;
var project = null;
var groundtruthProject = null;
var projects = {};
var projectSelector = null;

var filteredEmail = null;

window.projects = projects;

function isemail(s) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(s);
}

var saveConfigTid = null;
function saveConfig() {
    var cfg = [
        imageZoom,
        itemsPerPage,
        showLabels,
        showDetails,
        showControls,
        sortIndex,
        sortDir,
        filters,
        project,
        currentPage || 0,
        $('.imgcls-browse').scrollTop(),
    ]
    var scfg = btoa(JSON.stringify(cfg))
    if (!window.GlobalVars.config) window.GlobalVars.config = {}
    descriptor.config = window.GlobalVars.config[descriptor.configId] = scfg;
    // console.log( 'SAVECONFIG', cfg, scfg )
    clearTimeout(saveConfigTid);
    setTimeout(function () {
        window.saveSession();
    }, 500)
}

var scrollTop = null;

function loadConfig(descriptor) {
    if (!descriptor.config) return;
    let sTop = 0;
    [
        descriptor.gridLayout.imageZoom,
        descriptor.gridLayout.itemsPerPage,
        descriptor.imageLayout.showLabels,
        descriptor.imageLayout.showDetails,
        descriptor.imageLayout.showControls,
        sortIndex,
        sortDir,
        filters,
        project,
        currentPage,
        scrollTop,
    ] = JSON.parse(atob(descriptor.config))
    if( !currentPage ) currentPage = 0;
    
    // console.log( 'loadConfig', [
    //     descriptor.gridLayout.imageZoom,
    //     descriptor.gridLayout.itemsPerPage,
    //     descriptor.imageLayout.showLabels,
    //     descriptor.imageLayout.showDetails,
    //     descriptor.imageLayout.showControls,
    //     sortIndex,
    //     sortDir,
    //     filters,
    // ], itemsPerPage )
}

var modelRunFilter = null;
var projectFilter = null;

function ckModelRunFilter() {
    modelRunFilter = projectFilter = null;
    if( !descriptor.datasetMode ) return;
    for( var ftr of filters ) {
        if( ftr.key == 'Model Run' && ftr.value ) {
            if( !modelRunFilter ) modelRunFilter = {};
            modelRunFilter[ftr.value] = 1;
        }
        if( ftr.key == 'Project' ) projectFilter = ftr.value;
    }
    var s = ['hide','show'];
    var a = s[modelRunFilter?1:0]
    // console.log( 'ckModelRunFilter', a )
    $('#dashboardButton')[a]();
}

function ckModelRun(){
    if( filters.filter( f => f.key == 'Model Run').length > 1 ) {
        window.filters = filters = filters.filter( ft => ft.key != 'Project')
        if( projectSelector ) {
            project = '';
            projectSelector.setValue('');
        }
        $('.imgcls-toolbar-project').hide();
        return true;
    }
    else {
        $('.imgcls-toolbar-project').show();
        return false;
    }
}

function ckFilterGlobal() {
    // return;
    if (!descriptor.datasetGlobalSearch) return;
    if( filters.length > 30 ) return console.log( 'over');
    let f = filters.filter(f => f.key == 'Dataset Type' && f.value > '');
    if (f.length == 0 && filterConfig['Dataset Type']) {
        console.log('ckFilterGlobal', [...filters], JSON.stringify(filters) )
        filters = filters.filter(f => f.key != 'Dataset Type');
        let dtDefault = 'image';
        if( filterConfig['Dataset Type'].indexOf(dtDefault) == -1 ) dtDefault = filterConfig['Dataset Type'][0];
        console.log( 'dtDefault', dtDefault )
        let uf = {
            "fid": 1,
            "key": "Dataset Type",
            "value": dtDefault,
            "type": 0,
            "value2": ""
        };
        filters.unshift(uf)
        return true;
    }
    return false;
}


window.drawFilter = drawFilter;
function drawFilter() {
    console.log( 'FILTERS', clone(filters))          

    ckModelRunFilter()
    ckFilterGlobal()
    console.log( 'FILTERS2', clone(filters))          
    function ckFilter(){
        var f = JSON.stringify([filters,sortIndex,sortDir]);
        if( f != filterSnapshot ) {
            filterSnapshot = f;
            queryFilter = true;
        }
    }
    ckModelRun()
    console.log( 'FILTERS3', clone(filters))          
    window.filters = filters;
    filteredEmail = descriptor.trainingType ? {} : null;
    // for (var i = filters.length - 1; i >= 0; i--) {
    //     var key = filters[i].key;
    //     if (!filterConfig[key]) filters.splice(i, 1);
    // }
    console.log( 'FILTERS4', clone(filters))          
    var addBlank = descriptor.datasetMode && filters.length == 1 && filters[0].key == 'Project';
    if (!filters.length || addBlank ) {
        // filters = [{ key: '_all', value: '', type: 0 }]
        filters.unshift({ key: '_all', value: '', type: 0 })
    }

    var fdiv = $('<div></div>');
    $('.imgcls-toolbar-filters').html('').append(fdiv)
    fdiv.html('<div class="imgcls-title">Filter</div>');


    var fsort = $('<div></div>');
    $('.imgcls-toolbar-sort').html('').append(fsort);

    function redraw() {
        filterVisible(function () {
            ckFilter();
            if (descriptor.classificationMode) drawTabs();
            draw();
        });

    }
    var fid = 1;
    function addFilter(ftr, add, del) {
        // console.log( 'ADDFILTER', ftr, add, del)

        var idx = filters.indexOf(ftr);
        var key = ftr.key;
        var val = ftr.value;
        var type = ftr.type;
        if( descriptor.datasetMode && key == 'Project' ) return;


        if (descriptor.trainingType && isemail(val)) {
            if (!filteredEmail) filteredEmail = {};
            filteredEmail[val] = 1;
            // console.log( 'EMAIL VAL', filteredEmail )
        }
        
        if (!ftr.fid) ftr.fid = fid++;
        if (!filterConfig[key]) return;
        var fterline = $('<div>').addClass('imgcls-filter-line').prop('id', 'filter-' + ftr.fid)
        function getVals(key) {
            if (!filterConfig[key]) return null;
            if (isarray(filterConfig[key])) var vals = filterConfig[key].map(v => v.toString());
            else var vals = Object.keys(filterConfig[key])
            // vals.unshift({ value: '', label: '&nbsp' }); mani
            vals.unshift({ value: '', label: 'Clear All' });
            return vals;
        }
        var dkeys = null;
        var dvals = null;
        var keys = Object.keys(filterConfig).filter(k => !k.match(/^_all/) && filterType[k] >= 0 );
        // var keys = Object.keys(filterConfig).filter(k => true && filterType[k] >= 0 );
        var allKey = '_all';
        if (descriptor.userRole.role == 'nlp_an') allKey = '_all_an';
        if (descriptor.userRole.role == 'nlp_qc') allKey = '_all_qc';

        keys.unshift({ value: allKey, label: 'All fields' });
        var dkeys = frm.dropDown(fterline, keys, key, { width: 150 }, function (v) {
            if (ftr.key !== v) {
                ftr.key = v;
                ftr.value = '';
                ftr.value2 = '';
                // if( dvals ) dvals.setOptions( getVals(v), ftr.value);
                ftr.type = filterType[ftr.key];
                drawFilter();
                redraw();
            }
        }).addClass('imgcls-dropdown-value'); // modify imgcls-dropdown-key to imgcls-dropdown-value 21/07 mani
        var w = type ? 177 : 359;
        if (!type) {
            var vopt = { placeholder: 'Select Value', width: w };

            if( filterConfig[key].length == 0 ) {
                vopt.dynamicSearch = function( drp, s ) {
                    // console.log( 'MYDIN', drp, s )
                    if( s === '' || s == vopt.lastSearch ) return;
                    vopt.lastSearch = s;
                    clearTimeout( vopt.tid );
                    vopt.tid = setTimeout( function(){
                        var payload = clone( descriptor.baseMatch );
                        payload.key = key;
                        payload.search = s;
                        console.log( 'search', s )
                        window.post('get_filter', payload, res => {
                            var list = res.data;
                            drp.setOptions( list )
                        })
                    }, 250 )
                    
                }
            }
            var keys = getVals(key);
            if( !filterConfig[key].length ) keys.push( val );
            var dvals = frm.dropDown(fterline, keys, val, vopt, function (v) {
                if (ftr.value != v) {
                    var ov = ftr.value;
                    ftr.value = v;
                    if (descriptor.trainingType && isemail(v)) {
                        if (!filteredEmail) filteredEmail = {};
                        filteredEmail[v] = 1;
                        delete filteredEmail[ov];
                        // console.log( 'EMAIL VAL', filteredEmail )
                    }
                    if( ckFilterGlobal() ) drawFilter()
                    // console.log('VALUE', v)
                    saveConfig()
                    redraw();
                }
            }).addClass('imgcls-dropdown-value');
        }
        else {
            var dvals = frm.dropDown(fterline, getVals(key), ftr.value, { placeholder: 'Initial Value', width: w }, function (v) {
                if (ftr.type == 1 && v !== '' ) v = v == 'none' ? 0 : v * 1
                if (ftr.value !== v) {
                    ftr.value = v;
                    if (ftr.value2 !== '' && ftr.value > ftr.value2) {
                        [ftr.value, ftr.value2] = [ftr.value2, ftr.value];
                        drawFilter();
                    }
                    // console.log('VALUE', v)
                    saveConfig()
                    redraw();
                }
            }).addClass('imgcls-dropdown-value');
            var dvals2 = frm.dropDown(fterline, getVals(key), ftr.value2, { placeholder: 'Final Value', width: w }, function (v) {
                if (ftr.type == 1 && v !== '') v = v == 'none' ? 0 : v * 1
                if (ftr.value2 !== v) {
                    ftr.value2 = v;
                    if (ftr.value !== '' && ftr.value > ftr.value2) {
                        [ftr.value, ftr.value2] = [ftr.value2, ftr.value];
                        drawFilter();
                    }
                    // console.log('VALUE2', v)
                    saveConfig()
                    redraw();
                }
            }).addClass('imgcls-dropdown-value');
        }
        if (add) {
            var addbtn = $('<button>').prop('idx', idx).prop('title', 'add new filter').html('<i class="fa fa-plus-circle fa-lg"></i>').addClass('imgcls-button-add').on('click', function () {
                var idx = $(this).prop('idx');
                // console.log( 'idx', idx )
                filters.splice(idx + 1, 0, { key: '_all', value: '', type: 0 })
                drawFilter();
                redraw();
                saveConfig()
            });
            fterline.append(addbtn)
        }
        if (del) {
            var delbtn = $('<button>').prop('idx', idx).prop('title', 'remove filter').html('<i class="fa fa-times-circle fa-lg"></i>').addClass('imgcls-button-add imgcls-button-del').on('click', function () {
                var idx = $(this).prop('idx');
                // console.log( 'idx', idx )
                filters.splice(idx, 1)
                drawFilter();
                redraw();
                saveConfig()
            });
            fterline.append(delbtn)
        }
        fdiv.append(fterline);
    }
    for (var f of filters) {
        addFilter(f, true, true);
    }
    // console.log( 'FILTERS', filters ); 
    // SOrt Panel

    var keys = Object.keys(filterConfig).filter(k => !k.match(/^_all/) && filterType[k] >= 0 );
    // keys.unshift({ value: '', label: '&nbsp;' }); mani to change below line
    keys.unshift({ value: '', label: 'Clear All' });
    fsort.html('<div class="imgcls-title">Sort By</div>');
    var skeys = frm.dropDown(fsort, keys, sortIndex,  {placeholder: 'select value', width: 150 }, function (v) {
        if (v != sortIndex) {
            sortIndex = v;
            saveConfig();
            redraw();
        }
    }).addClass('imgcls-dropdown-value'); // modify imgcls-dropdown-key to imgcls-dropdown-value 21/07 mani
    var skeys = frm.dropDown(fsort, [{ value: 1, label: 'Ascending' }, { value: -1, label: 'Descending' }], sortDir, { width: 150 }, function (v) {
        if (v != sortDir) {
            sortDir = v;
            saveConfig();
            redraw();
        }
    }).addClass('imgcls-dropdown-value'); // modify imgcls-dropdown-key to imgcls-dropdown-value 21/07 mani
    ckFilter();
}

function qFilter( callback ) {
    console.log( 'qFilter', clone(filters))
    var fmatch = [];
    for( var f of filters ) {
        var k = f.key == 'All fields' ? '_filter._all': '_filter.'+f.key;
        if( f.type == 0 ) {
            if( typeof(f.value) == 'boolean' ) f.value = f.value.toString();
            if( f.value > '') fmatch.push({[k]:f.value});
        } 
        else {
            if( f.value === '' && f.value2 === '') continue;
            var cmp = {};
            var v1 = -Number.MAX_VALUE;
            var v2 = Number.MAX_VALUE;
            if( f.value !== '' ) {
                var v1 = parseFloat(f.value) || 0;
                cmp.$gte = v1;
            }
            if( f.value2 !== '' ) {
                var v2 = parseFloat(f.value2) || 0;
                cmp.$lte = v2;
            }
            if( v1*v2 <= 0 ) {
                fmatch.push({$or:[{[k]:cmp},{[k]:'none'}]});
            } else {
                fmatch.push({[k]:cmp});
            }
        }
    }
    if( !fmatch.length ) fmatch = {};
    else if( fmatch.length == 1 ) fmatch = fmatch[0]; 
    else fmatch = {$and:fmatch};
    // console.log( 'fmatch', JSON.stringify(fmatch) )
    if( sortIndex ) {
        fmatch._sort = '_filter.'+sortIndex;
        fmatch._sortDir = sortDir;
    }
    return fmatch;
}

function draw(scrolTop) {
    // console.log('draw')
    // $('.imgcls-main').css({paddingTop:$('.imgcls-toolbar').height()})
    cleanImages();
    var out = [];
    var psize = itemsPerPage;
    var browse = $('.imgcls-browse');
    var img = null;
    while (1) {
        var offset = currentPage * psize;
        if (offset >= filteredImages.length && currentPage > 0) currentPage--;
        else break;
    }
    if (queryFilter ) {
        var ftr = qFilter();
        console.log('QUERY FILTER', JSON.stringify(ftr))
        queryFilter = false;
        // currentPage = 0;
        descriptor.progressiveLoad( {
            start:0, 
            filter:ftr,
        }, res => {
            initImageList();
            // for( var i = 0 ; i < res.length ; i++ ) {
            //     var img = res[i];
            //     imageList[i] = img;
            //     img.id = i;
            //     descriptor.dataset[i] = img;
            // }
            mkAnnotationData();
            filterVisible(() => {
                actionCheck();
                draw(scrolTop);
                actionCheck();
            });
        });
        return;
    }
    if( filteredImages.length && !filteredImages[offset].imageUrl ) {
        var ftr = qFilter();
        descriptor.progressiveLoad( {
            start:offset, 
            filter:ftr,
        }, res => {
            for( var i = 0 ; i < res.length ; i++ ) {
                var io = i + offset;
                var img = res[i];
                imageList[io] = img;
                img.id = io;
                descriptor.dataset[io] = img;
            }
            mkAnnotationData( offset, offset+res.length )
            filterVisible( () => {
                draw(scrolTop);
                actionCheck();
            });
        });
        return;
    }
    // console.log( 'psize', psize, 'offset', offset )
    for (var i = 0; i < psize; i++) {
        var io = i + offset;
        if (io >= filteredImages.length) break;
        img = filteredImages[io];
        out.push('<filter id="filter' + img.id + '"><feColorMatrix type="matrix" values="10 0.00 0.00 0.00 0.00 0.00 1.00 0.00 0.00 0.00 0.00 0.00 1.00 0.00 0.00 0.00 0.00 0.00 1.00 0.00"></feColorMatrix></filter>');
    }
    $('#svgfilters').html(out.join('\n'));

    if( descriptor.similarSearch && window.isDev ) {
        $('.imgcls-tool').hide();
        $('.imgcls-toolbar-compare').show().html('Items similar to <b>' + descriptor.similarSearch.itemId + '</b> <i class="fa fa-close pointer"></i>')
        $('.imgcls-toolbar-compare').find('I').on('click', async function(){
            window.GlobalVars.currentDataset.similarSearch = descriptor.similarSearch = null;
            await window.saveSession();
            $('.imgcls-toolbar-compare').html('').hide();
            refreshItems(function(){
                frm.loadingOut();
                draw();
            });
        })
    }
    else {
        $('.imgcls-tool').show();
    }

    for (var i = 0; i < psize; i++) {
        var io = i + offset;
        if (io >= filteredImages.length) break;
        img = filteredImages[io];
        addImage(browse, img);
    }
    if (descriptor.classificationMode) drawTabs();
    countSelected();
    if (filteredImages.length > psize) pagination(currentPage, filteredImages)
    else paginationOut();
    setZoom(imageZoom);
    drawResize();
    if (scrolTop) {
        $('.imgcls-browse').scrollTop(scrolTop);
    }
}

function ckAcknowledge() {
    var aval = 'documentsRead';
    if (!descriptor.qualificationMode || !descriptor.qualificationFiles || !descriptor.qualificationFiles.length) return true;
    if (descriptor.acknowledge.indexOf(aval) >= 0) return true;
    var btn = 'I have read the document' + (descriptor.qualificationFiles.length > 1 ? 's' : '');
    frm.myAlert('Important Documents', $('.imgcls-toolbar-documents').html(), btn, function () {
        window.post('user_acknowledge', { key: descriptor.acknowledgeKey, val: aval }, res => {
            descriptor.acknowledge.push(aval);
        })
    }, 'Later');
    return false;
}

function ckTrain() {
    if (descriptor.qualificationMode == 1) {
        var tot = 0;
        var err = 0;
        for (var i of imageList) {
            tot++;
            if (i.classification != i.finalClassification) err++;
        }
        if (err) {
            frm.myAlert('Please check again', '<b>' + err + '</b> of the ' + tot + ' items were <b>misclassified</b>. Please check the correct result and try again.')
            return false;
        }
    }
    return true;
}


function drawResize() {
    var browse = $('.imgcls-browse');
    if (!browse.length) {
        $(window).off('resize');
        return;
    }
    var mtop = $('.imgcls-main').offset().top
    var pos = $('.imgcls-toolbar').offset()
    // console.log( 'pos', pos )
    var top = pos.top - mtop + $('.imgcls-toolbar').height();
    var left = 0;
    var height = $(window).height() - top - mtop
    // console.log( 'top', top, 'left', left, 'height', height, $(window).height())
    browse.css({ position: 'absolute', paddingTop: 0, top: top, left: left, height: height })
    $('#root').css({ height: $(window).height(), overflow: 'hidden' })
}

function zoomSize() {
    var wmargin = 26;
    var wmargin = 26;
    return ($('.imgcls-browse').width() - wmargin) / imageZoom - 30;
}

var setZoomTid = null;
var lastImageZoom = -1;
function setZoom(z, slider) {
    hideDetail();
    z = Math.round(z)

    // if( lastImageZoom == z ) return;
    imageZoom = lastImageZoom = z;

    zoomSlider.val(z)

    var browse = $('.imgcls-browse');
    var size = zoomSize();
    var extraH = 0;
    if (showLabels) extraH += $('.imgcls-image-label').height();
    if (showControls) extraH += $('.imgcls-image-controls').height();
    $('.imgcls-image-container').css({ width: size })
    $('.imgcls-image-box').css({ width: size - 10, height: size - 10 })


    var w = $('.imgcls-browse').width();
    // var size = w/2;
    $('.imgcls-image-container-detail').css({ width: size * 2 })
    $('.imgcls-image-box-detail').css({ width: size * 2 - 10, height: size * 2 - 10 })
    // draw();
    // if( slider ) draw();
    // console.log('zoom', z)
    var touched = $('#' + imageLastTouched);
    if (touched.length) {
        var scroll = browse.scrollTop();
        var pos = touched.position();
        var top = pos.top + scroll;
        var bot = touched.height() + top;
        var maxh = browse.height();
        // console.log( 'touched', top, bot, maxh )
        if (top < scroll) {
            browse.scrollTop(top)
        }
        else if ((scroll + maxh) < bot) {
            if (maxh > touched.height) {
                browse.scrollTop(bot - maxh)
            }
            else {
                browse.scrollTop(top)
            }
        }
    }
}


var setPageSizeTid = null;
var lastItemsPerPage = -1;
function setPageSize(s) {
    hideDetail();
    var v = Math.round(s / 20) * 20;
    if (lastItemsPerPage == v) return;
    itemsPerPage = lastItemsPerPage = v;
    pageSizeSlider.val(itemsPerPage)
    draw();
}

var initImageDone = false;

function initImageList() {
    // console.log( 'initImageList', imageList, descriptor.dataset )
    // if( !initImageDone || imageList.length != descriptor.dataset.length ) 
    window.imageList = imageList = [];
    initImageDone = true;
    // console.log( 'initImageList', descriptor.dataset, descriptor.dataset.length )
    let idx = 0;
    for (var img of descriptor.dataset) {
        if( !img ) img = {}
        else {
            if (!img.label) img.label = img.imageUrl.replace(/\?.*/, '').replace(/.*\//, '')
            if (!img.classification) img.classification = labelUnclassified;
        }
        img.id = imageList.length;
        if( !imageList[idx] ) imageList[idx] = {};
        for( let k in img ) imageList[idx][k] = img[k];
        // imageList.push(clone(img))
        idx++;
    }
}

function initFilter(desc) {
    loadConfig(desc);
    descriptor = desc;
    filterSnapshot = JSON.stringify([filters,sortIndex,sortDir])
    return qFilter();
}

var zoomSlider = null;
var pageSizeSlider = null;
var showLabelsSwitch = null;
var showDetailsSwitch = null;
var showControlsSwitch = null;
var setLabelsTid = null;
var setDetailsTid = null;
var setControlsTid = null;

function init(desc, skipIni) {
    loadConfig(desc);
    gDataset = desc.datasetData || {};
    gDatasetId = gDataset.datasetId || null;
    // console.log( 'gDataset', gDataset)
    // gProjectId = window. GlobalVars.PDFProjectId;
    gProject = desc.projectData || {};
    gProjectId = gProject.id;
    stateLabels = window.stateLabels;
    $('.imgcls-toolbar').removeClass('hidden')
    if (!skipIni) {
        $('.imgcls-browse').addClass('scroll-thin') 
        // $('.imgcls-browse').addClass('')
        descriptor = desc;
        imgKey = (descriptor.baseMatch && descriptor.baseMatch.key) || 'itemId';
        window.descriptor = descriptor;
        if (!descriptor.imageControls) descriptor.imageControls = {};
        if (!descriptor.imageLayout) descriptor.imageLayout = {};
        if (!descriptor.gridLayout) descriptor.gridLayout = {};

        $('.imgcls-main').append($('<svg id="svgfilters" xmlns="http://www.w3.org/2000/svg" style="position: absolute; width: 0px; height: 0px;"></svg>'))
        imageZoom = descriptor.gridLayout.imageZoom || imageZoom;
        zoomSlider = addSlider($('.imgcls-toolbar-sliders'), {
            label: 'Image Size',
            min: 12,
            max: 4,
            reset: imageZoom,
            ini: imageZoom,
            addClass: 'imgcls-toolbar-inline',
            width: 200,
            showValue: function (v) { return Math.floor(100 / v) + '%' }
        }, function (v) {
            clearTimeout(setZoomTid);
            setZoomTid = setTimeout(function () {
                setZoom(v, true)
                saveConfig()
            }, 25);
        })
        itemsPerPage = descriptor.gridLayout.itemsPerPage || itemsPerPage;
        pageSizeSlider = addSlider($('.imgcls-toolbar-sliders'), {
            label: 'Page Size',
            min: 20,
            max: 100,
            reset: itemsPerPage,
            ini: itemsPerPage,
            width: 200,
            addClass: 'imgcls-toolbar-inline',
            showValue: function (v) { return v }
        }, function (v) {
            clearTimeout(setPageSizeTid);
            setPageSizeTid = setTimeout(function () {
                setPageSize(v);
                saveConfig()
            }, 25);
        })

        showControls = descriptor.imageLayout.showControls || showControls;
        showLabels = descriptor.imageLayout.showLabels || showLabels;
        showDetails = descriptor.imageLayout.showDetails || showDetails;

        if (descriptor.gridLayout.toggleLabels) {
            showLabelsSwitch = addSlider($('.imgcls-toolbar-sliders'), {
                label: 'Labels',
                ini: showLabels,
                width: 170,
                addClass: 'imgcls-toolbar-inline',
                switch: true,
                showValue: function (v) { return v ? 'visible' : 'hidden' }
            }, function (v) {
                clearTimeout(setLabelsTid);
                setLabelsTid = setTimeout(function () {
                    showLabels = v;
                    saveConfig()
                    draw();
                }, 25);
            })
        }

        if (descriptor.gridLayout.toggleDetails) {
            var detTitle = 'Details';
            if (descriptor.qualificationMode == 1) detTitle = 'Results'
            showDetailsSwitch = addSlider($('.imgcls-toolbar-sliders'), {
                label: detTitle,
                ini: showDetails,
                width: 170,
                addClass: 'imgcls-toolbar-inline',
                switch: true,
                showValue: function (v) { return v ? 'visible' : 'hidden' }
            }, function (v) {
                clearTimeout(setDetailsTid);
                setDetailsTid = setTimeout(function () {
                    showDetails = v;
                    saveConfig()
                    draw();
                }, 25);
            })
        }

        if (descriptor.gridLayout.toggleControls ) 
        {
            showControlsSwitch = addSlider($('.imgcls-toolbar-sliders'), {
                label: 'Controls',
                ini: showControls,
                width: 170,
                addClass: 'imgcls-toolbar-inline',
                switch: true,
                showValue: function (v) { return v ? 'visible' : 'hidden' }
            }, function (v) {
                clearTimeout(setControlsTid);
                setControlsTid = setTimeout(function () {
                    showControls = v;
                    saveConfig()
                    draw();
                }, 25);
            })
        }

        var ds = clone(descriptor.dataset);
        $(window).off('resize').on('resize', pageResize);
        if (descriptor.qualificationMode && descriptor.qualificationFiles && descriptor.qualificationFiles.length) {
            var fident = { sopFileName: 'SOP', manualFileName: 'Manual' };
            var msg = ['Please read the']
            var flist = [];
            for (var f of descriptor.qualificationFiles) {
                flist.push('<a href="' + f.url + '" target="_blank">' + fident[f.var] + '</a>');
            }
            msg = msg.concat(flist.join(' and '));
            msg.push('before starting your training');
            $('.imgcls-toolbar-commands').append($('<div class="imgcls-toolbar-documents">' + msg.join(' ') + '</div>'))
            ckAcknowledge()
        }
        if (descriptor.bookmarkURL) {
            var msg = 'For image references, please check the <a id="bookmarkURL" href="' + descriptor.bookmarkURL + '" target="_blank">reference Dataset</a>'
            $('.imgcls-toolbar-commands').append($('<div class="imgcls-toolbar-documents">' + msg + '</div>'));
            $('#bookmarkURL').on('click', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                window.post('bookmark_access', { project: descriptor.bulkProject }, () => {
                    $('#bookmarkURL').off('click')[0].click();
                })
            })
        }
        if (descriptor.classificationMode) {
            setButtons(descriptor)
        }
        ckModelRunFilter();

        $('.imgcls-browse').off('scroll').on('scroll', saveConfig )
        if (descriptor.datasetMode ) {
            var dashAction = $('<Button id="dashboardButton" type="submit" class="ml-2 mt-2 btn btn-secondary" >Dashboard</Button>')
            dashAction.on('click', function(){
                descriptor.dashboardFunc(qFilter(), filters);
            });
            $('.imgcls-toolbar-commands').append( dashAction);
            if(!modelRunFilter || descriptor.compareMode ) $('#dashboardButton').remove();
            if( !descriptor.blockEdit) {
                var exportButton = $('<Button id="exportProject" type="submit" class="ml-2 mt-2 btn btn-secondary btn-export" >Export Dataset</Button>')
                exportButton.on('click', function () { exportPopup() })

                if( gDataset.currentRecipes && gDataset.currentRecipes['Q&A'] ) {
                    // var promptButton = $('<Button id="promptButton" type="submit" class="ml-2 mt-2 btn btn-pink" ><i class="fa fa-comment"></i> Prompt</Button>')
                    // promptButton.on('click', function () { runPrompt() })
                    // $('.imgcls-toolbar-commands').append( promptButton);
                }
        
                var selAction = $('<Button id="selectedAction" type="submit" class="ml-2 mt-2 btn btn-pink" >Action <i class="fa fa-caret-down"></i></Button>')
                selAction.on('click', actionPopup);
                // $('.imgcls-toolbar-commands').append(exportButton, selAction);
                if (!($("#selectedAction").length > 0)){
                    $('.imgcls-toolbar-commands').append( selAction);
                }
                
                if (!window.hasPriv('admin', 'c_admin', 'c_super', 'd_super')) {
                    $('.btn-export').remove();
                }
            }
        }
        if ( descriptor.projectMode ) {
            var dashAction = $('<Button id="dashboardButton" type="submit" class="ml-2 mt-2 btn btn-secondary" >Dashboard</Button>')
            dashAction.on('click', descriptor.dashboardFunc);
            $('.imgcls-toolbar-commands').append(dashAction);
            if( !descriptor.blockEdit) {
                var exportButton = $('<Button id="exportProject" type="submit" class="ml-2 mt-2 btn btn-secondary btn-export" >Export Project</Button>')
                exportButton.on('click', function () { exportProjectPopup() });
                var selAction = $('<Button id="selectedAction" type="submit" class="ml-2 mt-2 btn btn-pink" >Action <i class="fa fa-caret-down"></i></Button>')
                selAction.on('click', actionPopup);
                // $('.imgcls-toolbar-commands').append(exportButton, dashAction, selAction);
                $('.imgcls-toolbar-commands').append(selAction);
                if (!window.hasPriv('admin', 'c_admin', 'c_super', 'd_super')) {
                    $('.btn-export').remove();
                }
            }
        }
    }


    imageList = [];

    initImageList();
    if (descriptor.configLock) {
        $('.imgcls-toolbar-commands').hide();
        $('.imgcls-toolbar-filters').hide();
        $('.imgcls-toolbar-sort').hide();
        $('.imgcls-toolbar-project').hide();
        $('.imgcls-toolbar-tabs').hide();
        $('.top-nav').hide();
    }
    setFilters();
    filterVisible(function () {
        draw(scrollTop)
        actionCheck();
    });
    descriptor.imageList = imageList;
    saveConfig();
    // draw();
}

function loading(str) {
    if (!str) str = '';
    $('.lds-hourglass').remove();

    var ld = $('<div class="lds-hourglass loading"><div class="lds-text">' + str + '</div></div>').css({
        position: 'fixed',
        // top:$('#maincolumn').outerHeight()/2-40,
        // top:$(window).height()/2-40,
        top: $(document.body).outerHeight() / 2 - 40,
        left: $('#maincolumn').width() / 2 - 40 + mainLeftOffset,
    })
    $('#maincolumn').append(ld);

}

function loadingOut() {
    $('.loading').remove();
}

function pageResize() {
    setZoom(imageZoom);
    draw();
    drawResize()
}

function setResize() {
    $(window).off('resize').on('resize', pageResize );
    drawResize();
}


// EXPORTEND

// ADL

// export default {init,loading,loadingOut,updating};
export default { init, loading, loadingOut, setResize, initFilter };